import { Component } from "react";
import {
  Card,
  Button,
  Form,
  Row,
  Col,
  Tooltip,
  OverlayTrigger,
  Spinner,
} from "react-bootstrap";
import configData from "../../config.json";
import { toast } from "react-toastify";
// import { Bar, Doughnut, Line, Pie } from "react-chartjs-2";
import "./Charts.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import * as Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import funnelModule from "highcharts/modules/funnel";
import exportingModule from "highcharts/modules/exporting";
import offlineExporting from "highcharts/modules/offline-exporting";
import highchartsMore from "highcharts/highcharts-more";
import solidGauge from "highcharts/modules/solid-gauge";
import variablePie from "highcharts/modules/variable-pie";
import heatmap from "highcharts/modules/heatmap";
import treemap from "highcharts/modules/treemap";
import sunburst from "highcharts/modules/sunburst";
import sankey from "highcharts/modules/sankey";
import dependencyWheel from "highcharts/modules/dependency-wheel";
import networkgraph from "highcharts/modules/networkgraph";
import organization from "highcharts/modules/organization";
import timeline from "highcharts/modules/timeline";
import xrange from "highcharts/modules/xrange";
import histogram from "highcharts/modules/histogram-bellcurve";
import pareto from "highcharts/modules/pareto";
import bullet from "highcharts/modules/bullet";
//import windbarb from "highcharts/modules/windbarb";
// import cylinder from "highcharts/modules/cylinder";
import venn from "highcharts/modules/venn";
import wordcloud from "highcharts/modules/wordcloud";
import streamgraph from "highcharts/modules/streamgraph";
import tilemap from "highcharts/modules/tilemap";
import item from "highcharts/modules/item-series";
import dumbbell from "highcharts/modules/dumbbell";
import lollipop from "highcharts/modules/lollipop";
import variwide from "highcharts/modules/variwide";
/// Initialize all modules
const modules = [
  highchartsMore,
  solidGauge,
  variablePie,
  heatmap,
  treemap,
  sunburst,
  sankey,
  dependencyWheel,
  networkgraph,
  organization,
  timeline,
  xrange,
  histogram,
  pareto,
  bullet,
  //windbarb,
  //cylinder,
  venn,
  wordcloud,
  streamgraph,
  tilemap,
  item,
  dumbbell,
  lollipop,
  variwide,
  funnelModule,
  exportingModule,
  offlineExporting,
];

modules.forEach((module) => {
  if (typeof module === "function") {
    module(Highcharts);
  } else if (typeof module?.default === "function") {
    module.default(Highcharts);
  }
});

const normalizeDataType = (value) => String(value || "").toLowerCase();

// Chart type configuration
const CHART_CONFIGS = {
  // Single Axis Charts (Group By only)
  SINGLE_AXIS: [
    "PIE",
    "DONUT",
    "GAUGE",
    "SOLIDGAUGE",
    "CARD",
    "BISCUIT",
    "SUNBURST",
    "TREEMAP",
    "WORDCLOUD",
    "PACKEDBUBBLE",
    "VENN",
  ],

  // Dual Axis Charts (X-Axis + Y-Axis with aggregation)
  DUAL_AXIS: [
    "LINE",
    "SPLINE",
    "AREA",
    "AREASPLINE",
    "BAR",
    "COLUMN",
    "SCATTER",
    "BUBBLE",
    "FUNNEL",
    "PYRAMID",
    "WATERFALL",
    "STACKEDBAR",
    "STACKEDCOLUMN",
    "STACKEDAREA",
    "GROUPEDBAR",
    "HEATMAP",
    "BOXPLOT",
    "ERRORBAR",
    "COLUMNRANGE",
    "AREARANGE",
    "BARTARGET",
    "MULTIBARTARGET",
    "VARIABLERADIUSPIE",
    "HISTOGRAM",
    "BELLCURVE",
    "PARETO",
    "BULLET",
    "LOLLIPOP",
    "DUMBBELL",
    //"WINDBARB",
    "VARIWIDE",
    "STREAMGRAPH",
    "POLAR",
    "RADIALBAR",
  ],

  // Special/Relational Charts (require specific data structure)
  RELATIONAL: [
    "SANKEY",
    "DEPENDENCYWHEEL",
    "NETWORKGRAPH",
    "ORGANIZATION",
    "TIMELINE",
    "XRANGE",
    "ARCDIAGRAM",
    "TREEGRAPH",
    "ITEM",
    "VECTORPLOT",
    "PARALLELCOORDINATES",
    "PICTORIAL",
  ],
};
// import Drilldown from "highcharts/modules/drilldown";
export default class ChartWidget extends Component {
  constructor(props) {
    super(props);
    this.state = {
      step: 1,
      loading: false,
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      widgetslibrary_Id: sessionStorage.getItem("widgetslibrary_Id"),
      chartType: "",
      xAxisColumn: "",
      yAxisColumn: "",
      tableName: "",
      tables: [],
      columns: [],
      rcolumns: [],
      columnsWT: [],
      conditions: [],
      previewdata: [],
      selectedColumns: {
        xAxis: { name: "", alias: "", operation: "", columnType: "" },
        yAxis: { name: "", alias: "", operation: "", columnType: "" },
      },
      savedConfigurations: [],
      currentChartData: null,
      widgetId: "",
      widgetName: "",
      widgetDescription: "",
      columnName: "",
      dataTypeOne: "",
      value1: "",
      columnTwo: "",
      dataTypeTwo: "",
      formulaTwo: "",
      columnThree: "",
      dataTypeThree: "",
      formulaThree: "",
      columnFour: "",
      dataTypeFour: "",
      formulaFour: "",
      groupbyColumn: "",
      drilldownWhere: "",
      drilldownGroupby: "",
      sourcereportId: "",
      destinationreportId: "",
      valueOperator: "",
      drilldownvalue: "",
      extractMonth: null,
      extractYear: null,
      chartmasterlist: [],
      rConditions: {
        tableName: "",
        columnName: "",
        columnName2: "",
        columnName3: "",
        columnName4: "",
      },
      rowscondition: [
        {
          columnName2: "",
          columnvalueOperator: "",
          logicalOperator: "",
          value1: "",
        },
      ],
      selectedColumnDataType: "",
      // chartData: null,
      highchartsOptions: null,
      drilldownData: null,
      selectedValue: null,
      chartData: [],
      drillDownData: [],
      selectedChart: "pie",
      cardTitle: "",
      mergeIntoSingleCard: false,
      employees: [],
    };
  }

  componentDidMount() {
    this.getTables();
    this.chartmasterlist();
    this.EmployeesfetchHandler();
  }
  chartmasterlist = (e) => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    fetch(configData.api_url + "C_Charttypemaster/list", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        if (data.status === "success") {
          this.setState({
            chartmasterlist: data.list,
          });
        } else {
          this.showToast(data.message || "Failed to load chart types", "error");
        }
      })
      .catch((error) => {
        console.error("Error fetching chart master list:", error);
        this.showToast(
          "Failed to load chart types. Please try again.",
          "error",
        );
      });
  };
  EmployeesfetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    fetch(configData.api_url + "C_Employees/list", {
      // Enter your IP address here

      method: "POST",
      //headers :{ 'Content-Type' : 'application/json'},
      mode: "cors",
      body: formData, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ employees: data.list });
        }
      });
  };
  handleChartTypeChange = (e) => {
    const chartType = e.target.value;
    const selectedChart = this.state.chartmasterlist.find(
      (chart) => chart.chartName === chartType,
    );

    this.setState({
      chartType,
      // Clear previous preview so old chart doesn't linger / mix with new selection
      chartData: [],
      drillDownData: [],
      highchartsOptions: null,
      ...(selectedChart
        ? {
            maxHeight: selectedChart.maxHeight,
            maxWidth: selectedChart.maxWidth,
            minHeight: selectedChart.minHeight,
            minWidth: selectedChart.minWidth,
          }
        : {}),
    });
  };
  showToast = (msg, type) => {
    switch (type) {
      case "success":
        toast.success(msg);
        break;
      case "error":
        toast.error(msg);
        break;
      case "warning":
        toast.warn(msg);
        break;
      default:
        toast.info(msg);
    }
  };

  getTables = () => {
    const formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);

    fetch(configData.api_url + "/masters/gettables", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        if (data.status === "success") {
          this.setState({ tables: data.tables });
          this.showToast(data.message, data.status);
        } else {
          this.showToast(data.message || "Failed to load tables", "error");
        }
      })
      .catch((error) => {
        console.error("Error fetching tables:", error);
        this.showToast(
          "Failed to load tables. Please check your connection.",
          "error",
        );
      });
  };

  getColumns = (tableName) => {
    const formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("tableName", tableName);

    fetch(configData.api_url + "/masters/getcolumns", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        if (data.status === "success") {
          this.setState({ columns: data.columns });
          this.showToast(data.message, data.status);
        } else {
          this.showToast(data.message || "Failed to load columns", "error");
        }
      })
      .catch((error) => {
        console.error("Error fetching columns:", error);
        this.showToast(
          "Failed to load columns. Please check your connection.",
          "error",
        );
      });
  };

  handleNextWidStep = () =>
    this.setState((prevState) => ({ step: prevState.step + 1 }));

  handleNextStep = (e) => {
    e.preventDefault();
    //   setButtons(contacts);
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("widgetName", this.state.widgetName);
    formData.append("widgetDescription", this.state.widgetDescription);

    fetch(configData.api_url + "C_Widgetslibrary/add", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.setState({
            step: this.state.step + 1,
            widgetslibrary_Id: data.widgetslibrary_Id,
          });
          sessionStorage.setItem("widgetslibrary_Id", data.widgetslibrary_Id);
        }
      })
      .catch((error) => {
        console.error("Error creating widget:", error);
        this.showToast("Failed to create widget. Please try again.", "error");
      });
  };

  WidgetslibrarysubmitHandler = (e) => {
    e.preventDefault();
    if (this.state.isSubmitting) return;
    this.setState({ isSubmitting: true });
    const widgetslibrary_Id =
      this.state.widgetslibrary_Id ||
      sessionStorage.getItem("widgetslibrary_Id");
    console.log("Using widgetslibrary_Id:", widgetslibrary_Id);
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("widgetId", widgetslibrary_Id);
    formData.append("widgetName", this.state.widgetName);
    formData.append("chartType", this.state.chartType);
    formData.append("maxWidth", this.state.maxWidth);
    formData.append("minWidth", this.state.minWidth);
    formData.append("maxHeight", this.state.maxHeight);
    formData.append("minHeight", this.state.minHeight);
    formData.append("tableName", this.state.tableName);
    formData.append("columnName", this.state.columnName);
    // formData.append("value", "");
    formData.append("aggregation", this.state.aggregation);
    // const startIndex = 1;
    // const endIndex = 4;
    // for (let i = startIndex; i <= endIndex; i++) {
    //   const rowIndex = i - 1; // Map to rowscondition indices starting from 0
    //   const row = this.state.rowscondition[rowIndex] || {}; // Default to an empty object if no row exists

    //   const operator = row.columnvalueOperator || "";
    //   const value =
    //     operator === "Between" || operator === "Not Between"
    //       ? `${row.value1 || ""},${row.value2 || ""}` // Concatenate values with a comma
    //       : row.value1 || ""; // Use single value otherwise
    //   // Append row data or default to empty strings
    //   formData.append(`columnName${i}`, row.columnName || "");
    //   formData.append(`columnvalueOperator${i}`, operator);
    //   formData.append(`logicalOperator${i}`, row.logicalOperator || "");
    //   formData.append(`value${i}`, value);
    // }
    const startIndex = 1;
    const endIndex = 4;
    const formatDate = (date) => {
      if (!date) return "";
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    };
    for (let i = startIndex; i <= endIndex; i++) {
      const rowIndex = i - 1;
      const row = this.state.rowscondition[rowIndex] || {};
      const operatorKey =
        i === 1 ? "columnvalueOperator" : `columnvalueOperator${i}`;
      const logicalKey = i === 1 ? "logicalOperator" : `logicalOperator${i}`;
      const valueKey = i === 1 ? "value1" : `value${i}`;

      // const operator = row[operatorKey] || "";
      const normalizedDataType = normalizeDataType(row.dataType);
      const isDateCol =
        normalizedDataType === "date" ||
        normalizedDataType === "datetime" ||
        normalizedDataType === "timestamp";
      const dateMode = row.dateValueMode || "calendar";
      let formattedValue;
      if (isDateCol && dateMode === "calendar") {
        formattedValue = formatDate(row.value1);
      } else {
        formattedValue = row.value1 || "";
      }
      formData.append(`columnName${i}`, row.columnName || "");
      formData.append(operatorKey, row.columnvalueOperator || "");
      formData.append(logicalKey, row.logicalOperator || "");
      formData.append(valueKey, formattedValue);
    }
    // const startIndex = 1;
    // const endIndex = 4;

    // for (let i = startIndex; i <= endIndex; i++) {
    //   const rowIndex = i - 1;
    //   const row = this.state.rowscondition[rowIndex] || {};

    //   // Dynamically set columnName key
    //   const columnNameKey = i === 1 ? "columnName" : `columnName${i}`;

    //   // Other keys follow a similar pattern
    //   const operatorKey =
    //     i === 1 ? "columnvalueOperator" : `columnvalueOperator${i}`;
    //   const logicalKey = i === 1 ? "logicalOperator" : `logicalOperator${i}`;
    //   const valueKey = i === 1 ? "value1" : `value${i}`;

    //   // Handle operator-specific value logic
    //   const operator = row[operatorKey] || "";
    //   const value =
    //     operator === "Between" || operator === "Not Between"
    //       ? `${row.value1 || ""},${row.value2 || ""}`
    //       : row.value1 || "";

    //   // Append values to formData with dynamic keys
    //   formData.append(columnNameKey, row.columnName || "");
    //   formData.append(operatorKey, operator);
    //   formData.append(logicalKey, row.logicalOperator || "");
    //   formData.append(valueKey, value);
    // }

    formData.append("arithematicOperator", "");
    formData.append("columnofArithematic", "");
    formData.append("groupbyColumn", this.state.groupbyColumn);
    formData.append("extractMonth", this.state.extractMonth);
    formData.append("extractYear", this.state.extractYear);
    formData.append("drilldownWhere", this.state.drilldownWhere);
    formData.append("drilldownGroupby", this.state.drilldownGroupby);
    formData.append("sourcereportId", this.state.sourcereportId);
    formData.append("destinationreportId", this.state.destinationreportId);
    formData.append("valueOperator", this.state.valueOperator);
    formData.append("drilldownvalue", this.state.drilldownvalue);
    formData.append("drilldownWhere", this.state.drilldownWhere);
    formData.append("employeeColumn", this.state.employeeColumn);
    formData.append("dummyone", "");
    formData.append("dummytwo", "");
    formData.append("dummythree", "");
    formData.append("dummyfour", "");
    formData.append("dummyfive", "");
    formData.append("dummysix", "");
    formData.append("dummyseven", "");
    formData.append("dummyeight", "");
    formData.append("dummynine", "");
    formData.append("dummyten", "");
    fetch(configData.api_url + "C_Widgetdefinition/add", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.setState({
            widgetslibrary_Id: "",
            widgetId: "",
            widgetName: "",
            chartType: "",
            tableName: "",
          });
        }
      })
      .catch((error) => {
        console.error("Error submitting widget definition:", error);
        this.showToast(
          "Failed to save widget definition. Please try again.",
          "error",
        );
      })
      .finally(() => this.setState({ isSubmitting: false }));
  };
  handleColumnSelection = (axis, column) => {
    const selectedColumn = this.state.columns.find(
      (col) => col.name === column,
    );
    this.setState((prevState) => ({
      selectedColumns: {
        ...prevState.selectedColumns,
        [axis]: {
          ...prevState.selectedColumns[axis],
          name: column,
          alias: column,
          columnType: selectedColumn?.type,
        },
      },
    }));
  };

  handleColumnAliasChange = (axis, alias) => {
    this.setState((prevState) => ({
      selectedColumns: {
        ...prevState.selectedColumns,
        [axis]: { ...prevState.selectedColumns[axis], alias },
      },
    }));
  };

  handleMathOperationChange = (axis, operation) => {
    this.setState((prevState) => ({
      selectedColumns: {
        ...prevState.selectedColumns,
        [axis]: { ...prevState.selectedColumns[axis], operation },
      },
    }));
  };
  WidgetslibraryfetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    fetch(configData.api_url + "C_Widgetslibrary/list", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        if (data.status === "success") {
          this.setState({ data: data.list });
        } else {
          this.showToast(
            data.message || "Failed to load widget library",
            "error",
          );
        }
      })
      .catch((error) => {
        console.error("Error fetching widget library:", error);
        this.showToast(
          "Failed to load widget library. Please try again.",
          "error",
        );
      });
  };
  handlePrevStep = () => {
    this.setState((prevState) => ({
      step: Math.max(prevState.step - 1, 1),
    }));
  };
  renderTooltip = (text) => <Tooltip id="button-tooltip">{text}</Tooltip>;
  handleColumnChange = (e) => {
    e.preventDefault();
    const fieldName = e.target.getAttribute("name");
    const fieldValue = e.target.value;
    const inputData = this.state;
    const selectedLabel = e.target.options[e.target.selectedIndex].text;
    inputData[fieldName] = selectedLabel;
    this.setState({ rConditions: inputData, columnValue: fieldValue });
  };
  handleColumnChangeone = (index, e) => {
    const selectedColumnName = e.target.value; // Get the selected column name

    // Find the selected column object based on the column name
    const selectedColumn = this.state.columns.find(
      (col) => col.COLUMN_NAME === selectedColumnName,
    );

    // If a valid column is selected
    if (selectedColumn) {
      const selectedDataType = selectedColumn.DATA_TYPE; // Get the data type

      this.setState((prevState) => {
        const rowscondition = [...prevState.rowscondition];

        // Update the row with the selected column name and its data type
        rowscondition[index] = {
          ...rowscondition[index],
          columnName: selectedColumnName,
          dataType: normalizeDataType(selectedDataType),
        };

        return { rowscondition };
      });
    } else {
      console.error(`Column "${selectedColumnName}" not found.`);
    }
  };

  inputSChange = (e) => {
    e.preventDefault();
    const fieldName = e.target.getAttribute("name");
    const fieldValue = e.target.value;
    const inputData = this.state;
    inputData[fieldName] = fieldValue;
    this.setState({ dataTypeOne: inputData });
    //this.setState({visibletype: e.target.value})
  };
  handleColumnOneChange = (e) => {
    e.preventDefault();
    const fieldName = e.target.getAttribute("name");
    const fieldValue = e.target.value;
    const inputData = this.state;
    inputData[fieldName] = fieldValue;
    this.setState({ rConditions: inputData });
  };

  inputtableSChange = (e) => {
    e.preventDefault();
    const fieldName = e.target.getAttribute("name");
    const fieldValue = e.target.value;
    const inputData = this.state;
    inputData[fieldName] = fieldValue;
    this.setState({ rConditions: inputData });
    this.getColumnsWT(fieldValue, "columns");
  };
  handledataTypeOneChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ dataTypeOne: fieldValue });
  };
  handlelogicalOperatorChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ logicalOperator: fieldValue });
  };
  handlevalue1Change = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ value1: fieldValue });
  };
  handlegroupbyColumnChange = (e) => {
    // e.preventDefault();
    // const fieldValue = e.target.value;
    // this.setState({ groupbyColumn: fieldValue });
    const selectedColumnName = e.target.value;
    const selectedColumn = this.state.columns.find(
      (col) => col.COLUMN_NAME === selectedColumnName,
    );

    this.setState({
      groupbyColumn: selectedColumnName,
      groupbyColumnType: selectedColumn
        ? normalizeDataType(selectedColumn.DATA_TYPE)
        : "",
    });
  };
  handleAggregateColumnChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ aggregation: fieldValue });
  };
  handleExactmonthChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ extractMonth: fieldValue });
  };
  handlewheredrilldownChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ drilldownWhere: fieldValue });
  };
  handlegroupbyChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ drilldownGroupby: fieldValue });
  };
  handlevalueOperatorChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ valueOperator: fieldValue });
  };
  handleddrilldownvalueChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ drilldownvalue: fieldValue });
  };
  handleDOJChange = (date) => {
    if (date) {
      const formattedDate = `${date.getFullYear()}-${(date.getMonth() + 1)
        .toString()
        .padStart(2, "0")}-${date.getDate().toString().padStart(2, "0")}`;
      console.log(date);
      console.log(formattedDate);
      // Assuming you want to update the 'dob' state with the selected date
      this.setState({
        extractYear: formattedDate,
        startDate: new Date(),
      });
    }
  };
  getColumnsWT = (tableName, rcolumn) => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("tableName", tableName);
    fetch(configData.api_url + "/masters/getcolumns", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        if (data.status === "success") {
          this.setState({ [rcolumn]: data.columnsWT });
          this.showToast(data.message, data.status);
        } else {
          this.showToast(data.message || "Failed to load columns", "error");
        }
      })
      .catch((error) => {
        console.error("Error fetching columns WT:", error);
        this.showToast(
          "Failed to load table columns. Please try again.",
          "error",
        );
      });
  };

  handleInputChange = (index, event) => {
    const { name, value } = event.target;
    this.setState((prevState) => {
      const updatedRows = [...prevState.rowscondition];
      updatedRows[index] = {
        ...updatedRows[index], // Clone the specific row
        [name]: value, // Update the specific field
      };
      return { rowscondition: updatedRows };
    });
  };
  handleDateChange = (index, date, fieldName) => {
    this.setState((prevState) => {
      const updatedRows = [...prevState.rowscondition];
      updatedRows[index] = {
        ...updatedRows[index],
        [fieldName]: date,
      };
      return { rowscondition: updatedRows };
    });
  };
  // handleAddRow = () => {
  //   const newRow = {
  //     columnValue: "",
  //     columnvalueOperator: "",
  //     logicalOperator: "",
  //     value2: "",
  //   };
  //   this.setState((prevState) => ({
  //     rowscondition: [...prevState.rowscondition, newRow],
  //   }));
  // };
  handleAddRow = () => {
    const maxRows = 4; // Limit to 3 rows
    this.setState((prevState) => {
      if (prevState.rowscondition.length < maxRows) {
        const newRow = {
          columnValue: "",
          columnvalueOperator: "",
          logicalOperator: "",
          value1: "",
        };
        return { rowscondition: [...prevState.rowscondition, newRow] };
      }
      return null; // Do nothing if maxRows is reached
    });
  };

  handleRemoveRow = (index) => {
    const updatedRows = this.state.rowscondition.filter(
      (_, rowIndex) => rowIndex !== index,
    );
    this.setState({ rowscondition: updatedRows });
  };

  toggleDatePlaceholder = (index) => {
    const updatedRows = [...this.state.rowscondition];
    updatedRows[index] = {
      ...updatedRows[index],
      usePlaceholder: !updatedRows[index].usePlaceholder,
      value1: "",
    };
    this.setState({ rowscondition: updatedRows });
  };

  renderConditionValueInput = (index, row) => {
    const normalizedDataType = normalizeDataType(row.dataType);
    const isDate =
      normalizedDataType === "date" ||
      normalizedDataType === "datetime" ||
      normalizedDataType === "timestamp";
    const op = (row.columnvalueOperator || "").toUpperCase();

    // Operators that need no value at all
    const noValueOps = [
      "TODAY",
      "YESTERDAY",
      "TOMORROW",
      "CURRENT MONTH",
      "CURRENT YEAR",
      "IS EMPTY",
      "IS NOT EMPTY",
    ];
    if (noValueOps.includes(op)) {
      return (
        <Form.Group controlId={`value1-${index}`}>
          <Form.Label>Value</Form.Label>
          <Form.Control
            type="text"
            disabled
            placeholder="No value needed"
            className="form-control"
          />
        </Form.Group>
      );
    }

    // For date columns: show mode selector (Calendar / Dynamic Date)
    if (isDate && row.columnvalueOperator) {
      const dateMode = row.dateValueMode || "calendar"; // "calendar" | "placeholder" | "custom"
      return (
        <Form.Group controlId={`value1-${index}`}>
          <Form.Label>Value</Form.Label>
          <Form.Select
            size="sm"
            value={dateMode}
            onChange={(e) => {
              const updatedRows = [...this.state.rowscondition];
              const mode = e.target.value;
              let val = "";
              if (mode !== "calendar" && mode !== "custom") {
                val = mode; // The mode IS the placeholder value (e.g. "CURDATE()")
              }
              updatedRows[index] = {
                ...updatedRows[index],
                dateValueMode: mode,
                value1: val,
              };
              this.setState({ rowscondition: updatedRows });
            }}
            className="mb-1"
          >
            <option value="calendar">Pick a Date</option>
            <optgroup label="Dynamic Dates">
              <option value="CURDATE()">Current Date (CURDATE)</option>
              <option value="STARTOFMONTH()">Start of Month</option>
              <option value="MONTH()">Month</option>
              <option value="ENDOFMONTH()">End of Month</option>
              <option value="STARTOFYEAR()">Start of Year</option>
              <option value="ENDOFYEAR()">End of Year</option>
              <option value="YESTERDAY()">Yesterday</option>
              <option value="LASTMONTHSTART()">Last Month Start</option>
              <option value="LASTMONTHEND()">Last Month End</option>
              <option value="STARTOFQUARTER()">Start of Quarter</option>
              <option value="STARTOFWEEK()">Start of Week</option>
            </optgroup>
            <option value="custom">Custom (type manually)</option>
          </Form.Select>
          {dateMode === "calendar" && (
            <DatePicker
              selected={row.value1 || null}
              onChange={(date) => this.handleDateChange(index, date, "value1")}
              dateFormat="dd/MM/yyyy"
              className="form-control"
              placeholderText="Select Date"
            />
          )}
          {dateMode === "custom" && (
            <>
              <Form.Control
                type="text"
                onChange={(e) => this.handleInputChange(index, e)}
                className="form-control"
                name="value1"
                value={row.value1 || ""}
                placeholder="e.g. CURDATE()-30 or CURDATE()+7"
              />
              <Form.Text className="text-muted" style={{ fontSize: "0.65rem" }}>
                CURDATE()+/-N for days offset. Comma-separated for Between.
              </Form.Text>
            </>
          )}
          {dateMode !== "calendar" && dateMode !== "custom" && (
            <Form.Control
              type="text"
              disabled
              value={row.value1 || dateMode}
              className="form-control"
            />
          )}
        </Form.Group>
      );
    }

    // Non-date columns: text input with hint
    return (
      <Form.Group controlId={`value1-${index}`}>
        <Form.Label>Value</Form.Label>
        <Form.Control
          type="text"
          onChange={(e) => this.handleInputChange(index, e)}
          className="form-control"
          name="value1"
          value={row.value1 || ""}
          placeholder="e.g. Active or Active,Relieved"
        />
        <Form.Text className="text-muted" style={{ fontSize: "0.65rem" }}>
          Comma-separated for multiple values (IN clause)
        </Form.Text>
      </Form.Group>
    );
  };

  // Fixed function with proper template literals
  // prepareStackedOrGroupedData = (flatData) => {
  //   const nameMap = {}; // { Karnataka: [2, 3], Telangana: [4, 2] }

  //   flatData.forEach((item) => {
  //     const { name, y } = item;
  //     if (!nameMap[name]) {
  //       nameMap[name] = [];
  //     }
  //     nameMap[name].push(y);
  //   });

  //   const categories = Object.keys(nameMap); // ["Karnataka", "Telangana", ...]
  //   const maxStack = Math.max(
  //     ...Object.values(nameMap).map((arr) => arr.length)
  //   );

  //   const series = [];

  //   for (let i = 0; i < maxStack; i++) {
  //     series.push({
  //       name: `Value ${i + 1}`,
  //       data: categories.map((name) => nameMap[name][i] || 0),
  //     });
  //   }

  //   return {
  //     categories,
  //     series,
  //   };
  // };
  prepareStackedOrGroupedData = (chartData) => {
    if (!chartData || !Array.isArray(chartData) || chartData.length === 0) {
      return { categories: [], series: [] };
    }
    const uniqueCategories = Array.from(
      new Set(chartData.map((item) => item.name)),
    );
    const maxOccurrences = {};
    uniqueCategories.forEach((category) => {
      maxOccurrences[category] = chartData.filter(
        (item) => item.name === category,
      ).length;
    });
    const maxSeriesNeeded = Math.max(...Object.values(maxOccurrences));
    const series = [];
    for (let i = 0; i < maxSeriesNeeded; i++) {
      series.push({ name: `Series ${i + 1}`, data: [] });
    }
    uniqueCategories.forEach((category) => {
      const occurrences = chartData
        .filter((item) => item.name === category)
        .map((item) => parseInt(item.y) || 0);
      for (let i = 0; i < maxSeriesNeeded; i++) {
        series[i].data.push(i < occurrences.length ? occurrences[i] : 0);
      }
    });
    const colors = this.generateColors(maxSeriesNeeded);
    series.forEach((s, index) => {
      s.color = colors[index % colors.length];
    });
    return { categories: uniqueCategories, series: series };
  };
  // Check if chart type requires single or dual axis
  isSingleAxisChart = (chartType) => {
    return CHART_CONFIGS.SINGLE_AXIS.includes(chartType?.toUpperCase());
  };

  isDualAxisChart = (chartType) => {
    return CHART_CONFIGS.DUAL_AXIS.includes(chartType?.toUpperCase());
  };

  isRelationalChart = (chartType) => {
    return CHART_CONFIGS.RELATIONAL.includes(chartType?.toUpperCase());
  };
  getPreviewXAxisLabel = () => this.state.groupbyColumn || "Category";
  getPreviewYAxisLabel = () => this.state.columnName || "Values";
  getPreviewSeriesLabel = () => this.state.columnName || "Data";
  getCardConditionLabel = () => {
    const stageCondition = (this.state.rowscondition || []).find((row) => {
      const columnName = String(row?.columnName || "")
        .trim()
        .toLowerCase();
      const value = String(row?.value1 || "").trim();
      return columnName === "stagename" && value;
    });

    return stageCondition ? String(stageCondition.value1).trim() : "";
  };
  getCardDisplayName = (item) => {
    const possibleLabels = [
      item?.label,
      item?.category,
      item?.stageName,
      item?.groupName,
      item?.x,
      item?.name,
    ];

    const textLabel = possibleLabels.find((value) => {
      if (value === null || value === undefined) return false;
      const normalizedValue = String(value).trim();
      if (!normalizedValue) return false;
      return Number.isNaN(Number(normalizedValue));
    });

    return (
      textLabel ||
      this.getCardConditionLabel() ||
      this.state.widgetName ||
      "Metric"
    );
  };
  getCardTrendDirection = (displayName, comparisonValue, mainValue) => {
    const normalizedName = String(displayName || "")
      .trim()
      .toLowerCase();
    const negativeKeywords = [
      "lost",
      "loss",
      "rejected",
      "reject",
      "failed",
      "fail",
      "cancelled",
      "canceled",
      "closed lost",
    ];
    const positiveKeywords = ["won", "win", "success", "closed won"];

    if (negativeKeywords.some((keyword) => normalizedName.includes(keyword))) {
      return "negative";
    }

    if (positiveKeywords.some((keyword) => normalizedName.includes(keyword))) {
      return "positive";
    }

    if (comparisonValue > 0) {
      return mainValue >= comparisonValue ? "positive" : "negative";
    }

    return "positive";
  };
  getCurrentMonthLabel = () =>
    new Date().toLocaleString("en-US", { month: "short", year: "numeric" });
  getPreviousMonthLabel = () => {
    const previousMonth = new Date();
    previousMonth.setMonth(previousMonth.getMonth() - 1);
    return previousMonth.toLocaleString("en-US", {
      month: "short",
      year: "numeric",
    });
  };
  createDirectHighchartsOptions = (chartData, drillDownData, chartType) => {
    if (!chartData || chartData.length === 0) return null;
    if (chartType === "CARD" || chartType === "BISCUIT") return {};

    const xAxisLabel = this.getPreviewXAxisLabel();
    const yAxisLabel = this.getPreviewYAxisLabel();
    const seriesLabel = this.getPreviewSeriesLabel();

    const baseOptions = {
      chart: { type: this.mapChartType(chartType) },
      title: { text: this.state.widgetName || "Data Visualization" },
      credits: { enabled: false },
      exporting: { enabled: true },
      legend: { enabled: true },
      tooltip: { pointFormat: "{series.name}: <b>{point.y}</b>" },
    };

    const insideLabel = (rotation = 0) => ({
      enabled: true,
      inside: true,
      verticalAlign: "middle",
      align: "center",
      rotation,
      crop: false,
      overflow: "allow",
      style: {
        fontWeight: "bold",
        fontSize: "13px",
        color: "#ffffff",
        textOutline: "1px contrast",
      },
      formatter: function () {
        return this.y;
      },
    });

    const upperType = chartType?.toUpperCase();
    const columnRotation = -90;

    switch (upperType) {
      case "PIE":
      case "DONUT":
        return {
          ...baseOptions,
          plotOptions: {
            pie: {
              allowPointSelect: true,
              cursor: "pointer",
              dataLabels: {
                enabled: true,
                distance: "-30%",
                format: "{point.y}",
                style: {
                  fontWeight: "bold",
                  fontSize: "13px",
                  color: "#ffffff",
                  textOutline: "1px contrast",
                },
              },
              showInLegend: true,
              innerSize: chartType === "DONUT" ? "50%" : 0,
            },
          },
          series: [{ name: seriesLabel, colorByPoint: true, data: chartData }],
          drilldown: { series: drillDownData },
        };

      case "LINE":
      case "SPLINE":
        return {
          ...baseOptions,
          xAxis: { type: "category", title: { text: xAxisLabel } },
          yAxis: { title: { text: yAxisLabel } },
          series: [
            {
              name: seriesLabel,
              data: chartData,
              dataLabels: {
                enabled: true,
                style: { fontWeight: "bold", fontSize: "12px" },
                formatter: function () {
                  return this.y;
                },
              },
            },
          ],
          drilldown: { series: drillDownData },
        };

      case "AREA":
      case "AREASPLINE":
        return {
          ...baseOptions,
          chart: { type: chartType === "AREASPLINE" ? "areaspline" : "area" },
          xAxis: { type: "category", title: { text: xAxisLabel } },
          yAxis: { title: { text: yAxisLabel } },
          plotOptions: {
            area: { fillOpacity: 0.5, marker: { enabled: false } },
            areaspline: { fillOpacity: 0.5, marker: { enabled: false } },
          },
          series: [
            {
              name: seriesLabel,
              data: chartData,
              dataLabels: {
                enabled: true,
                style: { fontWeight: "bold", fontSize: "12px" },
                formatter: function () {
                  return this.y;
                },
              },
            },
          ],
        };

      case "BAR":
      case "COLUMN":
        return {
          ...baseOptions,
          xAxis: { type: "category", title: { text: xAxisLabel } },
          yAxis: { title: { text: yAxisLabel } },
          series: [
            {
              name: seriesLabel,
              colorByPoint: true,
              data: chartData,
              dataLabels: insideLabel(
                upperType === "COLUMN" ? columnRotation : 0,
              ),
            },
          ],
          drilldown: { series: drillDownData },
        };

      case "SCATTER":
        return {
          ...baseOptions,
          chart: { type: "scatter", zoomType: "xy" },
          xAxis: { title: { text: xAxisLabel } },
          yAxis: { title: { text: yAxisLabel } },
          plotOptions: {
            scatter: {
              marker: { radius: 5 },
              dataLabels: {
                enabled: true,
                style: { fontWeight: "bold", fontSize: "12px" },
                formatter: function () {
                  return this.y;
                },
              },
            },
          },
          series: [
            {
              name: seriesLabel,
              data: chartData.map((item, idx) => [idx, item.y]),
            },
          ],
        };

      case "BUBBLE":
        return {
          ...baseOptions,
          chart: { type: "bubble", zoomType: "xy" },
          xAxis: { title: { text: xAxisLabel } },
          yAxis: { title: { text: yAxisLabel } },
          series: [
            {
              name: seriesLabel,
              data: chartData.map((item, idx) => ({
                x: idx,
                y: item.y,
                z: item.z || item.y,
              })),
              dataLabels: {
                enabled: true,
                inside: true,
                style: {
                  fontWeight: "bold",
                  fontSize: "12px",
                  color: "#ffffff",
                  textOutline: "1px contrast",
                },
                formatter: function () {
                  return this.y;
                },
              },
            },
          ],
        };

      case "FUNNEL":
        return {
          ...baseOptions,
          chart: { type: "funnel" },
          plotOptions: {
            series: {
              dataLabels: {
                enabled: true,
                format: "{point.y}",
                inside: true,
                align: "center",
                verticalAlign: "middle",
                style: {
                  fontWeight: "bold",
                  fontSize: "13px",
                  color: "#ffffff",
                  textOutline: "1px contrast",
                },
              },
              center: ["50%", "50%"],
              neckWidth: "30%",
              neckHeight: "25%",
              width: "80%",
            },
          },
          series: [{ name: seriesLabel, data: chartData }],
        };

      case "PYRAMID":
        return {
          ...baseOptions,
          chart: { type: "pyramid" },
          plotOptions: {
            series: {
              dataLabels: { ...insideLabel(0) },
              center: ["50%", "50%"],
              width: "80%",
            },
          },
          series: [{ name: seriesLabel, data: chartData }],
        };

      case "WATERFALL":
        return {
          ...baseOptions,
          chart: { type: "waterfall" },
          xAxis: { type: "category", title: { text: xAxisLabel } },
          yAxis: { title: { text: yAxisLabel } },
          series: [
            {
              name: seriesLabel,
              data: chartData.map((item, idx) => ({
                name: item.name,
                y: item.y,
                isSum: idx === chartData.length - 1,
              })),
              dataLabels: insideLabel(columnRotation),
            },
          ],
        };

      case "HEATMAP":
        return {
          ...baseOptions,
          chart: { type: "heatmap" },
          xAxis: {
            categories: chartData.map((_, idx) => `X${idx}`),
            title: { text: xAxisLabel },
          },
          yAxis: {
            categories: chartData.map((_, idx) => `Y${idx}`),
            title: { text: yAxisLabel },
          },
          colorAxis: { min: 0, minColor: "#FFFFFF", maxColor: "#003399" },
          series: [
            {
              name: seriesLabel,
              data: chartData.map((item, idx) => [
                idx % 5,
                Math.floor(idx / 5),
                item.y,
              ]),
              dataLabels: { enabled: true, color: "#000000" },
            },
          ],
        };

      case "TREEMAP":
        return {
          ...baseOptions,
          chart: { type: "treemap" },
          series: [
            {
              name: seriesLabel,
              data: chartData.map((item) => ({
                name: item.name,
                value: item.y,
                colorValue: item.y,
              })),
              layoutAlgorithm: "squarified",
              dataLabels: {
                enabled: true,
                format: "{point.value}",
                style: {
                  fontWeight: "bold",
                  fontSize: "13px",
                  color: "#ffffff",
                  textOutline: "1px contrast",
                },
              },
            },
          ],
        };

      case "SUNBURST":
        return {
          ...baseOptions,
          chart: { type: "sunburst" },
          series: [
            {
              name: seriesLabel,
              data: chartData.map((item, idx) => ({
                id: `${idx}`,
                name: item.name,
                value: item.y,
              })),
              levels: [
                {
                  level: 1,
                  levelIsConstant: false,
                  dataLabels: {
                    filter: {
                      property: "outerArcLength",
                      operator: ">",
                      value: 16,
                    },
                  },
                },
              ],
            },
          ],
        };

      case "SANKEY":
        return {
          ...baseOptions,
          chart: { type: "sankey" },
          series: [
            {
              name: "Flow",
              keys: ["from", "to", "weight"],
              data: chartData.map((item, idx) => [
                item.name,
                `Target ${idx}`,
                item.y,
              ]),
            },
          ],
        };

      case "DEPENDENCYWHEEL":
        return {
          ...baseOptions,
          chart: { type: "dependencywheel" },
          series: [
            {
              name: "Dependency",
              keys: ["from", "to", "weight"],
              data: chartData.map((item, idx) => [
                item.name,
                `Node ${idx}`,
                item.y,
              ]),
            },
          ],
        };

      case "NETWORKGRAPH":
        return {
          ...baseOptions,
          chart: { type: "networkgraph" },
          plotOptions: {
            networkgraph: {
              keys: ["from", "to"],
              layoutAlgorithm: { enableSimulation: true },
            },
          },
          series: [
            {
              data: chartData.map((item, idx) => [item.name, `Node ${idx}`]),
            },
          ],
        };

      case "ORGANIZATION":
        return {
          ...baseOptions,
          chart: { type: "organization", inverted: false },
          series: [
            {
              name: "Organization",
              keys: ["from", "to"],
              data: chartData
                .map((item, idx) => [
                  idx === 0 ? null : chartData[idx - 1].name,
                  item.name,
                ])
                .filter((d) => d[0] !== null),
              nodes: chartData.map((item) => ({
                id: item.name,
                title: item.name,
              })),
            },
          ],
        };

      case "TIMELINE":
        return {
          ...baseOptions,
          chart: { type: "timeline" },
          xAxis: { visible: false },
          yAxis: { visible: false },
          series: [
            {
              data: chartData.map((item) => ({
                name: item.name,
                label: item.name,
                description: `Value: ${item.y}`,
              })),
            },
          ],
        };

      case "XRANGE":
        return {
          ...baseOptions,
          chart: { type: "xrange" },
          xAxis: { type: "datetime" },
          yAxis: {
            title: { text: "" },
            categories: chartData.map((item) => item.name),
          },
          series: [
            {
              name: seriesLabel,
              data: chartData.map((item, idx) => ({
                x: Date.now(),
                x2: Date.now() + item.y * 86400000,
                y: idx,
              })),
            },
          ],
        };

      case "BOXPLOT":
        return {
          ...baseOptions,
          chart: { type: "boxplot" },
          xAxis: { categories: ["Sample"], title: { text: xAxisLabel } },
          yAxis: { title: { text: yAxisLabel } },
          series: [
            {
              name: seriesLabel,
              data: [
                [
                  Math.min(...chartData.map((d) => d.y)),
                  chartData[0]?.y,
                  chartData[Math.floor(chartData.length / 2)]?.y,
                  chartData[chartData.length - 1]?.y,
                  Math.max(...chartData.map((d) => d.y)),
                ],
              ],
            },
          ],
        };

      case "ERRORBAR":
        return {
          ...baseOptions,
          chart: { type: "column" },
          xAxis: { type: "category", title: { text: xAxisLabel } },
          yAxis: { title: { text: yAxisLabel } },
          series: [
            {
              name: seriesLabel,
              data: chartData.map((item) => item.y),
              type: "column",
              dataLabels: insideLabel(columnRotation),
            },
            {
              name: "Error",
              data: chartData.map((item) => [item.y - 5, item.y + 5]),
              type: "errorbar",
            },
          ],
        };

      case "COLUMNRANGE":
      case "AREARANGE":
        return {
          ...baseOptions,
          chart: { type: chartType.toLowerCase() },
          xAxis: { type: "category", title: { text: xAxisLabel } },
          yAxis: { title: { text: yAxisLabel } },
          series: [
            {
              name: seriesLabel,
              data: chartData.map((item) => [item.y - 10, item.y + 10]),
              dataLabels: {
                enabled: true,
                style: { fontWeight: "bold", fontSize: "12px" },
              },
            },
          ],
        };

      case "GAUGE":
        const gaugeValue = parseFloat(chartData[0]?.y || 0);
        const maxValue = this.state.targetValue || 1000;
        return {
          ...baseOptions,
          chart: {
            type: "gauge",
            plotBackgroundColor: null,
            plotBorderWidth: 0,
            plotShadow: false,
            height: "80%",
          },
          pane: {
            startAngle: -90,
            endAngle: 89.9,
            background: null,
            center: ["50%", "75%"],
            size: "110%",
          },
          yAxis: {
            min: 0,
            max: maxValue,
            plotBands: [
              { from: 0, to: maxValue * 0.6, color: "#DF5353", thickness: 20 },
              {
                from: maxValue * 0.6,
                to: maxValue * 0.8,
                color: "#DDDF0D",
                thickness: 20,
              },
              {
                from: maxValue * 0.8,
                to: maxValue,
                color: "#55BF3B",
                thickness: 20,
              },
            ],
          },
          series: [
            {
              name: seriesLabel,
              data: [gaugeValue],
              dataLabels: { format: "{y}" },
              dial: { radius: "80%", backgroundColor: "gray" },
            },
          ],
        };

      case "SOLIDGAUGE":
        const solidValue = parseFloat(chartData[0]?.y || 0);
        const solidMax = this.state.targetValue || 400;
        return {
          ...baseOptions,
          chart: { type: "solidgauge", height: "80%" },
          pane: {
            center: ["50%", "85%"],
            size: "140%",
            startAngle: -90,
            endAngle: 90,
            background: {
              backgroundColor: "#EEE",
              innerRadius: "60%",
              outerRadius: "100%",
              shape: "arc",
            },
          },
          yAxis: {
            min: 0,
            max: solidMax,
            stops: [
              [0.1, "#DF5353"],
              [0.5, "#DDDF0D"],
              [0.9, "#55BF3B"],
            ],
          },
          series: [
            {
              name: seriesLabel,
              data: [solidValue],
              dataLabels: {
                format:
                  '<div style="text-align:center"><span style="font-size:25px">{y}</span></div>',
              },
            },
          ],
        };

      case "VARIABLERADIUSPIE":
        return {
          ...baseOptions,
          chart: { type: "variablepie" },
          series: [
            {
              minPointSize: 10,
              innerSize: "20%",
              zMin: 0,
              name: seriesLabel,
              data: chartData,
              dataLabels: {
                enabled: true,
                format: "{point.y}",
                style: {
                  fontWeight: "bold",
                  fontSize: "13px",
                  color: "#ffffff",
                  textOutline: "1px contrast",
                },
                distance: "-30%",
              },
            },
          ],
        };

      case "HISTOGRAM":
        return {
          ...baseOptions,
          chart: { type: "histogram" },
          xAxis: { title: { text: yAxisLabel } },
          yAxis: { title: { text: "Frequency" } },
          series: [
            {
              name: seriesLabel,
              data: chartData.map((item) => item.y),
              dataLabels: insideLabel(columnRotation),
            },
          ],
        };

      case "BELLCURVE":
        return {
          ...baseOptions,
          chart: { type: "bellcurve" },
          xAxis: { title: { text: yAxisLabel } },
          yAxis: { title: { text: "Probability" } },
          series: [
            {
              name: seriesLabel,
              baseSeries: 1,
            },
            {
              name: seriesLabel,
              type: "scatter",
              data: chartData.map((item) => item.y),
              visible: false,
            },
          ],
        };

      case "PARETO":
        return {
          ...baseOptions,
          chart: { type: "column" },
          xAxis: { type: "category", title: { text: xAxisLabel } },
          yAxis: [
            { title: { text: yAxisLabel } },
            { title: { text: "Percentage" }, opposite: true },
          ],
          series: [
            {
              name: seriesLabel,
              type: "pareto",
              data: chartData,
              dataLabels: insideLabel(columnRotation),
            },
          ],
        };

      case "BULLET":
        return {
          ...baseOptions,
          chart: { type: "bullet", inverted: true, height: 150 },
          xAxis: { categories: ["Progress"], title: { text: xAxisLabel } },
          yAxis: {
            title: { text: yAxisLabel },
            plotBands: [
              { from: 0, to: this.state.targetValue || 800, color: "#f0f0f0" },
            ],
          },
          series: [
            {
              name: seriesLabel,
              data: [
                {
                  y: chartData[0]?.y || 0,
                  target: this.state.targetValue || 800,
                },
              ],
              dataLabels: insideLabel(0),
            },
          ],
        };

      case "WINDBARB":
        return {
          ...baseOptions,
          chart: { type: "windbarb" },
          xAxis: { type: "datetime" },
          yAxis: { title: { text: yAxisLabel } },
          series: [
            {
              name: seriesLabel,
              data: chartData.map((item, idx) => [
                Date.now() + idx * 3600000,
                item.y,
                45,
              ]),
            },
          ],
        };

      case "VENN":
        return {
          ...baseOptions,
          chart: { type: "venn" },
          series: [
            {
              name: "Venn",
              data: chartData.map((item, idx) => ({
                sets: [item.name],
                value: item.y,
              })),
              dataLabels: {
                enabled: true,
                format: "{point.value}",
                style: {
                  fontWeight: "bold",
                  fontSize: "13px",
                  color: "#ffffff",
                  textOutline: "1px contrast",
                },
              },
            },
          ],
        };

      case "WORDCLOUD":
        return {
          ...baseOptions,
          chart: { type: "wordcloud" },
          series: [
            {
              name: "Occurrences",
              data: chartData.map((item) => ({
                name: item.name,
                weight: item.y,
              })),
            },
          ],
        };

      case "STREAMGRAPH":
        return {
          ...baseOptions,
          chart: { type: "streamgraph" },
          xAxis: { type: "category", title: { text: xAxisLabel } },
          yAxis: { visible: false },
          series: chartData.reduce((acc, item) => {
            if (!acc[0]) acc[0] = { name: seriesLabel, data: [] };
            acc[0].data.push(item.y);
            return acc;
          }, []),
        };

      case "ITEM":
        return {
          ...baseOptions,
          chart: { type: "item" },
          series: [
            {
              name: "Items",
              keys: ["name", "y", "color"],
              data: chartData.map((item) => [
                item.name,
                item.y,
                this.generateColors(1)[0],
              ]),
              dataLabels: {
                enabled: true,
                format: "{point.y}",
                style: { fontWeight: "bold", fontSize: "13px" },
              },
            },
          ],
        };

      case "DUMBBELL":
        return {
          ...baseOptions,
          chart: { type: "dumbbell" },
          xAxis: { type: "category", title: { text: xAxisLabel } },
          yAxis: { title: { text: yAxisLabel } },
          series: [
            {
              name: seriesLabel,
              data: chartData.map((item) => [
                item.name,
                item.y - 10,
                item.y + 10,
              ]),
              dataLabels: {
                enabled: true,
                style: { fontWeight: "bold", fontSize: "12px" },
              },
            },
          ],
        };

      case "LOLLIPOP":
        return {
          ...baseOptions,
          chart: { type: "lollipop" },
          xAxis: { type: "category", title: { text: xAxisLabel } },
          yAxis: { title: { text: yAxisLabel } },
          series: [
            {
              name: seriesLabel,
              data: chartData,
              dataLabels: {
                enabled: true,
                style: { fontWeight: "bold", fontSize: "12px" },
                formatter: function () {
                  return this.y;
                },
              },
            },
          ],
        };

      case "VARIWIDE":
        return {
          ...baseOptions,
          chart: { type: "variwide" },
          xAxis: { type: "category", title: { text: xAxisLabel } },
          yAxis: { title: { text: yAxisLabel } },
          series: [
            {
              name: seriesLabel,
              data: chartData.map((item) => [
                item.name,
                item.y,
                item.z || item.y,
              ]),
              dataLabels: insideLabel(columnRotation),
            },
          ],
        };

      case "POLAR":
        return {
          ...baseOptions,
          chart: { polar: true, type: "line" },
          xAxis: {
            categories: chartData.map((item) => item.name),
            tickmarkPlacement: "on",
            lineWidth: 0,
            title: { text: xAxisLabel },
          },
          yAxis: {
            gridLineInterpolation: "polygon",
            lineWidth: 0,
            min: 0,
            title: { text: yAxisLabel },
          },
          series: [
            {
              name: seriesLabel,
              data: chartData.map((item) => item.y),
              pointPlacement: "on",
              dataLabels: {
                enabled: true,
                style: { fontWeight: "bold", fontSize: "12px" },
                formatter: function () {
                  return this.y;
                },
              },
            },
          ],
        };

      case "RADIALBAR":
        return {
          ...baseOptions,
          chart: { polar: true, type: "column" },
          xAxis: {
            categories: chartData.map((item) => item.name),
            tickmarkPlacement: "on",
            lineWidth: 0,
            title: { text: xAxisLabel },
          },
          yAxis: {
            min: 0,
            endOnTick: false,
            showLastLabel: true,
            labels: { enabled: false },
            title: { text: yAxisLabel },
          },
          plotOptions: {
            column: {
              stacking: "normal",
              borderWidth: 0,
              pointPadding: 0,
              groupPadding: 0.15,
              dataLabels: insideLabel(0),
            },
          },
          series: [
            { name: seriesLabel, data: chartData.map((item) => item.y) },
          ],
        };

      case "STACKEDBAR":
      case "STACKEDCOLUMN":
        const stackedData = this.prepareStackedOrGroupedData(chartData);
        return {
          ...baseOptions,
          chart: { type: "column" },
          xAxis: {
            categories: stackedData.categories,
            crosshair: true,
            title: { text: xAxisLabel },
          },
          yAxis: {
            min: 0,
            title: { text: yAxisLabel },
            stackLabels: {
              enabled: true,
              style: { fontWeight: "bold", color: "black" },
            },
          },
          plotOptions: {
            column: {
              stacking: "normal",
              dataLabels: {
                ...insideLabel(
                  upperType === "STACKEDCOLUMN" ? columnRotation : 0,
                ),
                formatter: function () {
                  return this.y !== 0 ? this.y : null;
                },
              },
            },
          },
          series: stackedData.series,
        };

      case "STACKEDAREA":
        const stackedAreaData = this.prepareStackedOrGroupedData(chartData);
        return {
          ...baseOptions,
          chart: { type: "area" },
          xAxis: {
            categories: stackedAreaData.categories,
            title: { text: xAxisLabel },
          },
          yAxis: { title: { text: yAxisLabel } },
          plotOptions: {
            area: {
              stacking: "normal",
              lineColor: "#666666",
              lineWidth: 1,
              marker: { enabled: false },
              dataLabels: {
                enabled: true,
                style: { fontWeight: "bold", fontSize: "12px" },
                formatter: function () {
                  return this.y !== 0 ? this.y : null;
                },
              },
            },
          },
          series: stackedAreaData.series,
        };

      case "GROUPEDBAR":
        const groupedData = this.prepareStackedOrGroupedData(chartData);
        return {
          ...baseOptions,
          chart: { type: "column" },
          xAxis: {
            categories: groupedData.categories,
            crosshair: true,
            title: { text: xAxisLabel },
          },
          yAxis: { min: 0, title: { text: yAxisLabel } },
          plotOptions: {
            column: { grouping: true, dataLabels: insideLabel(columnRotation) },
          },
          series: groupedData.series,
        };

      case "BARTARGET":
        const barValue = parseFloat(chartData[0]?.y || 0);
        const targetValue = this.state.targetValue || 800;
        return {
          ...baseOptions,
          chart: { type: "bar", height: 150 },
          xAxis: { categories: ["Progress"], title: { text: xAxisLabel } },
          yAxis: {
            min: 0,
            max: targetValue * 1.2,
            title: { text: yAxisLabel, align: "high" },
            plotLines: [
              {
                color: "#000",
                width: 2,
                value: targetValue,
                zIndex: 4,
                label: {
                  text: "Target: " + targetValue,
                  align: "right",
                  style: { color: "#000", fontWeight: "bold" },
                },
              },
            ],
          },
          series: [
            {
              name: seriesLabel,
              data: [barValue],
              color: "#90ed7d",
              dataLabels: insideLabel(0),
            },
          ],
        };

      case "MULTIBARTARGET":
        const categories = chartData.map((item) => item.name);
        const achieved = chartData.map((item) => parseFloat(item.y || 0));
        const targets = chartData.map((item) =>
          parseFloat(item.target || item.z || 0),
        );
        return {
          ...baseOptions,
          chart: { type: "bar" },
          xAxis: { categories: categories, title: { text: xAxisLabel } },
          yAxis: { min: 0, title: { text: yAxisLabel, align: "high" } },
          plotOptions: {
            bar: { dataLabels: insideLabel(0) },
            series: { pointWidth: 20 },
          },
          series: [
            { name: seriesLabel, data: achieved, color: "#90ed7d" },
            {
              name: "Target",
              data: targets,
              color: "#434348",
              type: "scatter",
              marker: {
                symbol: "line",
                lineWidth: 2,
                radius: 8,
                lineColor: "#000",
              },
              dataLabels: { enabled: true, format: "Target: {y}" },
            },
          ],
        };

      case "PACKEDBUBBLE":
        return {
          ...baseOptions,
          chart: { type: "packedbubble" },
          plotOptions: {
            packedbubble: {
              minSize: "20%",
              maxSize: "100%",
              layoutAlgorithm: {
                gravitationalConstant: 0.05,
                splitSeries: true,
              },
              dataLabels: {
                enabled: true,
                format: "{point.value}",
                style: {
                  fontWeight: "bold",
                  fontSize: "13px",
                  color: "#ffffff",
                  textOutline: "1px contrast",
                },
              },
            },
          },
          series: [
            {
              name: seriesLabel,
              data: chartData.map((item) => ({
                name: item.name,
                value: item.y,
              })),
            },
          ],
        };

      case "VECTORPLOT":
        return {
          ...baseOptions,
          chart: { type: "vector" },
          xAxis: { min: 0, max: 10 },
          yAxis: { min: 0, max: 10 },
          series: [
            {
              name: "Vector",
              data: chartData.map((item, idx) => [idx, idx, item.y, item.y]),
            },
          ],
        };

      case "ARCDIAGRAM":
        return {
          ...baseOptions,
          chart: { type: "arcdiagram" },
          series: [
            {
              keys: ["from", "to", "weight"],
              data: chartData.map((item, idx) => [
                item.name,
                `Node ${idx}`,
                item.y,
              ]),
              linkWeight: 1,
            },
          ],
        };

      case "TREEGRAPH":
        return {
          ...baseOptions,
          chart: { type: "treegraph" },
          series: [
            {
              type: "treegraph",
              data: chartData.map((item, idx) => ({
                id: item.name,
                parent: idx === 0 ? "" : chartData[idx - 1].name,
                name: item.name,
              })),
            },
          ],
        };

      case "PICTORIAL":
        return {
          ...baseOptions,
          chart: { type: "pictorial" },
          series: [
            {
              name: "Data",
              data: chartData.map((item) => ({
                name: item.name,
                y: item.y,
                marker: {
                  symbol:
                    "url(https://www.highcharts.com/samples/graphics/sun.png)",
                },
              })),
            },
          ],
        };

      case "PARALLELCOORDINATES":
        return {
          ...baseOptions,
          chart: { type: "spline", parallelCoordinates: true },
          xAxis: {
            categories: chartData.map((item) => item.name),
            offset: 10,
            title: { text: xAxisLabel },
          },
          yAxis: chartData.map((item, idx) => ({
            min: 0,
            max: Math.max(...chartData.map((d) => d.y)),
            title: { text: item.name },
          })),
          series: [
            {
              name: seriesLabel,
              data: chartData.map((item) => item.y),
            },
          ],
        };

      default:
        return {
          ...baseOptions,
          xAxis: { type: "category", title: { text: xAxisLabel } },
          yAxis: { title: { text: yAxisLabel } },
          series: [{ name: seriesLabel, data: chartData }],
          drilldown: { series: drillDownData },
        };
    }
  };
  mapChartType = (chartType) => {
    const typeMap = {
      BAR: "column",
      COLUMN: "column",
      LINE: "line",
      SPLINE: "spline",
      PIE: "pie",
      DONUT: "pie",
      AREA: "area",
      AREASPLINE: "areaspline",
      SCATTER: "scatter",
      BUBBLE: "bubble",
      FUNNEL: "funnel",
      PYRAMID: "pyramid",
      WATERFALL: "waterfall",
      HEATMAP: "heatmap",
      TREEMAP: "treemap",
      SUNBURST: "sunburst",
      SANKEY: "sankey",
      DEPENDENCYWHEEL: "dependencywheel",
      NETWORKGRAPH: "networkgraph",
      ORGANIZATION: "organization",
      TIMELINE: "timeline",
      XRANGE: "xrange",
      BOXPLOT: "boxplot",
      ERRORBAR: "errorbar",
      COLUMNRANGE: "columnrange",
      AREARANGE: "arearange",
      GAUGE: "gauge",
      SOLIDGAUGE: "solidgauge",
      VARIABLERADIUSPIE: "variablepie",
      HISTOGRAM: "histogram",
      BELLCURVE: "bellcurve",
      PARETO: "pareto",
      BULLET: "bullet",
      WINDBARB: "windbarb",
      VENN: "venn",
      WORDCLOUD: "wordcloud",
      STREAMGRAPH: "streamgraph",
      ITEM: "item",
      DUMBBELL: "dumbbell",
      LOLLIPOP: "lollipop",
      VARIWIDE: "variwide",
      POLAR: "line",
      RADIALBAR: "column",
      STACKEDBAR: "column",
      STACKEDCOLUMN: "column",
      STACKEDAREA: "area",
      GROUPEDBAR: "column",
      BARTARGET: "bar",
      MULTIBARTARGET: "bar",
      PACKEDBUBBLE: "packedbubble",
      VECTORPLOT: "vector",
      ARCDIAGRAM: "arcdiagram",
      TREEGRAPH: "treegraph",
      PICTORIAL: "pictorial",
      PARALLELCOORDINATES: "spline",
      CARD: "card",
      BISCUIT: "biscuit",
    };
    return typeMap[chartType?.toUpperCase()] || "column";
  };
  // mapChartType = (chartType) => {
  //   switch (chartType) {
  //     case "BAR":
  //       return "column";
  //     case "LINE":
  //       return "line";
  //     case "PIE":
  //     case "DONUT":
  //       return "pie";
  //     case "STACKEDBAR":
  //     case "GROUPEDBAR":
  //       return "column";
  //     case "FUNNEL":
  //       return "funnel";
  //     case "VARIABLERADIUSPIE":
  //       return "variablepie";
  //     case "GAUGE":
  //       return "gauge";
  //     case "SOLIDGAUGE":
  //       return "solidgauge";
  //     case "BARTARGET":
  //       return "bar";
  //     case "MULTIBARTARGET":
  //       return "bar";
  //     case "CARD":
  //       return "card";
  //     case "BISCUIT":
  //       return null;
  //     default:
  //       return "column";
  //   }
  // };
  generateColors = (count) => {
    const colors = [
      "#FF6384",
      "#36A2EB",
      "#FFCE56",
      "#4BC0C0",
      "#9966FF",
      "#FF9F40",
      "#FF6384",
      "#C9CBCF",
      "#7CFC00",
      "#00FFFF",
    ];

    return colors.slice(0, count);
  };
  sortChartData = (data) => {
    if (!data || data.length === 0) return data;
    const isDate = (value) => !isNaN(Date.parse(value));
    const isNumber = (value) => !isNaN(parseFloat(value));
    return data.sort((a, b) => {
      // Sort by Y when number
      if (typeof a.y === "number" && typeof b.y === "number") {
        return b.y - a.y; // BIG → small
      }
      // Sort name when DATE
      if (isDate(a.name) && isDate(b.name)) {
        return new Date(b.name) - new Date(a.name); // Latest → oldest
      }
      // Sort name when NUMBER
      if (isNumber(a.name) && isNumber(b.name)) {
        return Number(b.name) - Number(a.name); // BIG → small
      }
      // Otherwise TEXT → alphabetical
      return a.name.localeCompare(b.name);
    });
  };
  HandlePreviewsubmitHandler = (e) => {
    e.preventDefault();
    if (this.state.isSubmitting) return;
    this.setState({ isSubmitting: true });
    const widgetslibrary_Id =
      this.state.widgetslibrary_Id ||
      sessionStorage.getItem("widgetslibrary_Id");
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("widgetId", widgetslibrary_Id);
    formData.append("widgetName", this.state.widgetName);
    formData.append("chartType", this.state.chartType);
    formData.append("maxWidth", this.state.maxWidth);
    formData.append("minWidth", this.state.minWidth);
    formData.append("maxHeight", this.state.maxHeight);
    formData.append("minHeight", this.state.minHeight);
    formData.append("tableName", this.state.tableName);
    formData.append("columnName", this.state.columnName);
    formData.append("aggregation", this.state.aggregation);
    const startIndex = 1;
    const endIndex = 4;
    const formatDate = (date) => {
      if (!date) return "";
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    };
    for (let i = startIndex; i <= endIndex; i++) {
      const rowIndex = i - 1;
      const row = this.state.rowscondition[rowIndex] || {};
      const operatorKey =
        i === 1 ? "columnvalueOperator" : `columnvalueOperator${i}`;
      const logicalKey = i === 1 ? "logicalOperator" : `logicalOperator${i}`;
      const valueKey = i === 1 ? "value1" : `value${i}`;
      const normalizedDataType = normalizeDataType(row.dataType);
      const isDateCol =
        normalizedDataType === "date" ||
        normalizedDataType === "datetime" ||
        normalizedDataType === "timestamp";
      const dateMode = row.dateValueMode || "calendar";
      let formattedValue;
      if (isDateCol && dateMode === "calendar") {
        formattedValue = formatDate(row.value1);
      } else {
        formattedValue = row.value1 || "";
      }
      formData.append(`columnName${i}`, row.columnName || "");
      formData.append(operatorKey, row.columnvalueOperator || "");
      formData.append(logicalKey, row.logicalOperator || "");
      formData.append(valueKey, formattedValue);
    }
    formData.append("arithematicOperator", "");
    formData.append("columnofArithematic", "");
    formData.append("groupbyColumn", this.state.groupbyColumn);
    formData.append("extractMonth", this.state.extractMonth);
    formData.append("extractYear", this.state.extractYear);
    formData.append("drilldownWhere", this.state.drilldownWhere);
    formData.append("drilldownGroupby", this.state.drilldownGroupby);
    formData.append("sourcereportId", this.state.sourcereportId);
    formData.append("destinationreportId", this.state.destinationreportId);
    formData.append("valueOperator", this.state.valueOperator);
    formData.append("drilldownvalue", this.state.drilldownvalue);
    fetch(configData.api_url + "C_Widgetdefinition/previewwidgetData1", {
      method: "POST",
      //headers :{ 'Content-Type' : 'application/json'},
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        // if (data.widgetData && data.widgetData.chart_data) {
        //  const chartData = data.chart_data;
        //   const drillDownData = data.drilldown_data;
        //   console.log(data);
        //   this.setState({
        //     chartData,
        //     drillDownData,
        //   });
        // }
        let chartData, drillDownData;

        if (data.widgetData && data.widgetData.chart_data) {
          // First case: data is inside widgetData property
          chartData = data.widgetData.chart_data;
          drillDownData = data.widgetData.drilldown_data;
        } else if (data.chart_data) {
          // Second case: data is directly in response
          chartData = data.chart_data;
          drillDownData = data.drilldown_data;
        }

        // Log extracted data for debugging
        console.log("Extracted chart data:", chartData);
        console.log("Extracted drilldown data:", drillDownData);

        if (chartData && chartData.length > 0) {
          // For CARD widget: when user opts in, collapse multiple grouped rows
          // into a single value (works around backend SQL error when groupby is empty)
          if (
            this.state.chartType === "CARD" &&
            this.state.mergeIntoSingleCard &&
            chartData.length > 1
          ) {
            const agg = (this.state.aggregation || "").toLowerCase();
            const totalY = chartData.reduce(
              (sum, item) => sum + (parseFloat(item.y) || 0),
              0,
            );
            const finalY =
              agg === "average" ? totalY / chartData.length : totalY;
            chartData = [
              {
                name: this.state.cardTitle || this.state.widgetName || "Total",
                y: finalY,
              },
            ];
          }

          // Create highcharts options immediately with this data
          const highchartsOptions = this.createDirectHighchartsOptions(
            chartData,
            drillDownData,
            this.state.chartType,
          );

          // Update state with all necessary data
          this.setState({
            chartData: chartData,
            drillDownData: drillDownData,
            highchartsOptions: highchartsOptions,
          });
        } else {
          console.error("No valid chart data found in API response");
          this.setState({
            chartData: null,
            drillDownData: null,
            highchartsOptions: null,
          });
        }
      })
      .catch((error) => {
        console.error("Error fetching or processing data:", error);
        this.setState({
          chartData: null,
          drillDownData: null,
          highchartsOptions: null,
        });
      })
      .finally(() => this.setState({ isSubmitting: false }));
  };
  formatIndianCurrency(value) {
    if (!value) return "₹0";
    return value.toLocaleString("en-IN", {
      style: "currency",
      currency: "INR",
      minimumFractionDigits: 2,
    });
  }
  formatCardValue = (value, aggregationType) => {
    if (aggregationType === "count") {
      return Math.round(value).toLocaleString();
    } else if (aggregationType === "sum" || aggregationType === "average") {
      // Format as currency
      if (value >= 1000000) {
        return `₹${(value / 1000000).toFixed(2)}M`;
      } else if (value >= 1000) {
        return `₹${(value / 1000).toFixed(2)}K`;
      } else {
        return `₹${value.toFixed(2)}`;
      }
    }
    return value.toLocaleString();
  };
  renderChartPreview = () => {
    const { chartType, chartData, highchartsOptions } = this.state;

    if (!chartData || chartData.length === 0) {
      return (
        <div>
          <p>
            No data available for preview. Please configure and click Preview..
          </p>
          <div
            style={{ fontSize: "10px", color: "gray", marginTop: "10px" }}
          ></div>
        </div>
      );
    }

    if (chartType === "BISCUIT") {
      // 1. Calculate the grand total for percentage calculation
      // Assuming 'y' holds the aggregated value (Sum, Avg, or Count)
      const grandTotal = chartData.reduce(
        (sum, item) => sum + (item.y || 0),
        0,
      );

      return (
        <div style={{ width: "100%", height: "100%" }}>
          <Card style={{ padding: "15px" }}>
            <h5 style={{ fontWeight: "600", marginBottom: "15px" }}>
              Top Deals
            </h5>

            {chartData.map((item, idx) => {
              // Calculate percentage here (omitted for brevity)
              const aggregatedValue = item.y || 0;
              const groupName = item.name || "N/A"; // Use item.name for the group label
              const percentage =
                grandTotal > 0
                  ? ((aggregatedValue / grandTotal) * 100).toFixed(1)
                  : 0;
              return (
                <div
                  key={idx}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "12px",
                  }}
                >
                  {/* LEFT — Group Name (e.g., Deal Name, Stage) */}
                  <span style={{ fontWeight: "600" }}>{groupName}</span>

                  {/* MIDDLE — Aggregated Value (e.g., Sum of Amount) */}
                  <span
                    style={{
                      fontWeight: "500",
                      textAlign: "right",
                      minWidth: "100px",
                    }}
                  >
                    {this.formatIndianCurrency(aggregatedValue)}
                  </span>

                  {/* RIGHT — Percentage (using your original percentage display) */}
                  <span
                    style={{
                      background: "#4CAF50",
                      color: "white",
                      padding: "4px 10px",
                      borderRadius: "20px",
                      fontSize: "12px",
                      marginLeft: "10px",
                    }}
                  >
                    {percentage}%
                    {/* Note: You must calculate the actual percentage here */}
                  </span>
                </div>
              );
            })}
          </Card>
        </div>
      );
    }
    if (chartType === "CARD") {
      return (
        <Row>
          {chartData.map((item, idx) => {
            const mainValue = item.y || 0;
            const comparisonValue = item.comparison || item.previous || 0;
            const displayName = this.getCardDisplayName(item);
            const hasComparisonData =
              Object.prototype.hasOwnProperty.call(item, "comparison") ||
              Object.prototype.hasOwnProperty.call(item, "previous");
            const currentMonthLabel = hasComparisonData
              ? this.getCurrentMonthLabel()
              : "";
            const previousMonthLabel = hasComparisonData
              ? this.getPreviousMonthLabel()
              : "";
            const cardTitleText = this.state.cardTitle
              ? this.state.cardTitle
              : hasComparisonData
                ? `${displayName} in ${currentMonthLabel}`
                : displayName;
            const trendDirection = this.getCardTrendDirection(
              displayName,
              comparisonValue,
              mainValue,
            );
            const isIncrease = trendDirection === "positive";
            const borderColor = isIncrease ? "#4CAF50" : "#f44336";
            const accentTextColor = isIncrease ? "#2e7d32" : "#c62828";
            const cardColumnProps =
              chartData.length === 1
                ? { xs: 12, sm: 12, md: 8, lg: 6, xl: 4 }
                : chartData.length === 2
                  ? { xs: 12, sm: 6, md: 6, lg: 6, xl: 4 }
                  : { xs: 12, sm: 6, md: 4, lg: 3, xl: 3 };

            return (
              <Col
                key={idx}
                {...cardColumnProps}
                style={{ marginBottom: "15px" }}
              >
                <Card
                  style={{
                    textAlign: "center",
                    padding: "0",
                    minHeight: "150px",
                    border: "1px solid #e5e7eb",
                    borderTop: `4px solid ${borderColor}`,
                    borderRadius: "10px",
                    boxShadow: "0 8px 18px rgba(15,23,42,0.08)",
                    backgroundColor: "#ffffff",
                    overflow: "hidden",
                  }}
                >
                  <Card.Body style={{ padding: "14px 16px 12px" }}>
                    <p
                      style={{
                        fontSize: "14px",
                        fontWeight: "600",
                        color: "#374151",
                        marginBottom: "14px",
                        minHeight: "40px",
                      }}
                    >
                      {cardTitleText}
                    </p>

                    <h2
                      style={{
                        fontSize: "42px",
                        fontWeight: "700",
                        color: "#111827",
                        marginBottom: "8px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "8px",
                      }}
                    >
                      {this.formatCardValue(mainValue, this.state.aggregation)}
                      <span
                        style={{
                          fontSize: "30px",
                          lineHeight: "1",
                          color: accentTextColor,
                        }}
                      >
                        {isIncrease ? "↑" : "↓"}
                      </span>
                    </h2>

                    {hasComparisonData && (
                      <p
                        style={{
                          fontSize: "13px",
                          color: "#6b7280",
                          marginTop: "0",
                          marginBottom: "0",
                          fontWeight: "600",
                        }}
                      >
                        {previousMonthLabel}:{" "}
                        {this.formatCardValue(
                          comparisonValue,
                          this.state.aggregation,
                        )}
                      </p>
                    )}
                  </Card.Body>
                </Card>
              </Col>
            );
          })}
        </Row>
      );
    }
    if (!highchartsOptions) {
      return (
        <div>
          <p>
            Unable to generate chart options. Please check your configuration.
          </p>
        </div>
      );
    }
    const chartHeight = this.calculateChartHeight(chartType, chartData.length);
    return (
      <HighchartsReact
        highcharts={Highcharts}
        options={highchartsOptions}
        containerProps={{
          style: { width: "100%", height: `${chartHeight}px` },
        }}
      />
    );
  };
  calculateChartHeight = (chartType, dataLength) => {
    const heights = {
      CARD: 200,
      BISCUIT: Math.max(200, dataLength * 60 + 80),
      BAR: Math.max(300, dataLength * 40 + 100),
      COLUMN: Math.max(300, dataLength * 40 + 100),
      STACKEDBAR: Math.max(300, dataLength * 40 + 100),
      STACKEDCOLUMN: Math.max(300, dataLength * 40 + 100),
      GROUPEDBAR: Math.max(300, dataLength * 40 + 100),
      FUNNEL: Math.max(350, dataLength * 50 + 100),
      PYRAMID: Math.max(350, dataLength * 50 + 100),
      PIE: 400,
      DONUT: 400,
      LINE: 350,
      SPLINE: 350,
      AREA: 350,
      AREASPLINE: 350,
      GAUGE: 300,
      SOLIDGAUGE: 300,
      BARTARGET: 200,
      MULTIBARTARGET: Math.max(250, dataLength * 50 + 100),
      VARIABLERADIUSPIE: 450,
      HEATMAP: 400,
      TREEMAP: 400,
      SUNBURST: 500,
      SANKEY: 400,
      DEPENDENCYWHEEL: 500,
      NETWORKGRAPH: 500,
      ORGANIZATION: 600,
      TIMELINE: 400,
      WORDCLOUD: 400,
      POLAR: 400,
      RADIALBAR: 400,
    };
    return heights[chartType?.toUpperCase()] || 400;
  };
  render() {
    const { step, widgetName, widgetDescription, chartType, tableName } =
      this.state;
    const previousYearStart = new Date();
    previousYearStart.setFullYear(previousYearStart.getFullYear() - 100);
    previousYearStart.setMonth(0); // Set the month to January
    previousYearStart.setDate(1);
    return (
      <div>
        {this.state.isSubmitting && (
          <div className="submit-loader-overlay">
            <div className="loader-content">
              <div className="app-loader">Loading...</div>
            </div>
            <div className="loader-text">Processing your request...</div>
          </div>
        )}

        <Row className="navigation-rows">
          <Col
            xs={4}
            sm={4}
            lg={4}
            className={`nav-item ${step === 1 ? "active-step" : ""}`}
          >
            <OverlayTrigger
              placement="top"
              overlay={this.renderTooltip("Profile Info")}
            >
              <Card
                className="nav-card"
                onClick={() => this.setState({ step: 1 })}
              >
                <span className="bi bi-boxes nav-icon"></span>
                <p className="nav-label">Profile Info</p>
              </Card>
            </OverlayTrigger>
          </Col>
          <Col
            xs={4}
            sm={4}
            lg={4}
            className={`nav-item ${step === 2 ? "active-step" : ""}`}
          >
            <OverlayTrigger
              placement="top"
              overlay={this.renderTooltip("Chart Selection")}
            >
              <Card
                className="nav-card"
                onClick={() => this.setState({ step: 2 })}
              >
                <span className="bi bi-journal-album nav-icon"></span>
                <p className="nav-label">Chart Selection</p>
              </Card>
            </OverlayTrigger>
          </Col>
          <Col
            xs={4}
            sm={4}
            lg={4}
            className={`nav-item ${step === 3 ? "active-step" : ""}`}
          >
            <OverlayTrigger
              placement="top"
              overlay={this.renderTooltip("Table Selection")}
            >
              <Card
                className="nav-card"
                onClick={() => this.setState({ step: 3 })}
              >
                <span className="bi bi-table nav-icon"></span>
                <p className="nav-label">Table Selection</p>
              </Card>
            </OverlayTrigger>
          </Col>
          {/* <Col
                  xs={3}
                  sm={3}
                  className={`nav-item ${step === 4 ? "active-step" : ""}`}
                >
                  <OverlayTrigger
                    placement="top"
                    overlay={this.renderTooltip("Summary")}
                  >
                    <Card
                      className="nav-card"
                      onClick={() => this.setState({ step: 4 })}
                    >
                      <span className="bi bi-file-earmark-check-fill nav-icon"></span>
                      <p className="nav-label">Summary</p>
                    </Card>
                  </OverlayTrigger>
                </Col> */}
        </Row>
        <br />
        <hr />
        {step === 1 && (
          <Row className="justify-content-center">
            <Col xs={12} sm={10} md={8} lg={6}>
              <Card>
                <Card.Header>Widget Name and Description</Card.Header>
                <Card.Body>
                  <Form>
                    <Form.Group controlId="textBox">
                      <Form.Label>Widget Name</Form.Label>
                      <Form.Control
                        type="text"
                        name="widgetName"
                        value={this.state.widgetName}
                        placeholder="Widget Name"
                        onChange={(e) =>
                          this.setState({ widgetName: e.target.value })
                        }
                      />
                    </Form.Group>
                    <Form.Group controlId="textArea">
                      <Form.Label>Widget Description</Form.Label>
                      <Form.Control
                        as="textarea"
                        name="widgetDescription"
                        value={this.state.widgetDescription}
                        placeholder="Widget Description"
                        onChange={(e) =>
                          this.setState({ widgetDescription: e.target.value })
                        }
                      />
                    </Form.Group>
                    <Button
                      variant="primary"
                      style={{ float: "right", marginTop: "5px" }}
                      onClick={this.handleNextStep}
                    >
                      Next
                    </Button>
                  </Form>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        )}

        {step === 2 && (
          <Row className="justify-content-center">
            <Col xs={12} sm={10} md={8} lg={6}>
              <Card>
                <Card.Header>Select Chart Type and Table</Card.Header>
                <Card.Body>
                  <Form>
                    <Form.Group controlId="chartType">
                      <Form.Label>Select Chart Type</Form.Label>
                      <Form.Control
                        as="select"
                        value={chartType}
                        // onChange={(e) =>
                        //   this.setState(
                        //     { chartType: e.target.value },
                        //     this.checkColumns
                        //   )
                        // }
                        onChange={this.handleChartTypeChange}
                        // onChange={(e) => this.setState({ chartType: e.target.value })}
                      >
                        <option value="">Select Chart Type</option>

                        {this.state.chartmasterlist.map((api, index, idx) => (
                          <option key={index} value={api.chartType}>
                            {api.chartName}
                          </option>
                        ))}
                      </Form.Control>
                    </Form.Group>
                    <Form.Group controlId="tableName">
                      <Form.Label>Select Data Source</Form.Label>
                      <Form.Control
                        as="select"
                        className="form-select"
                        value={this.state.tableName}
                        name="tableName"
                        onChange={this.inputtableSChange}
                      >
                        <option value="">Select Table</option>
                        {this.state.tables.map((api, index, idx) => (
                          <option key={index} value={api}>
                            {api}
                          </option>
                        ))}
                      </Form.Control>
                    </Form.Group>
                    <Button
                      variant="primary"
                      style={{ float: "right", marginTop: "5px" }}
                      onClick={this.handleNextWidStep}
                    >
                      Next
                    </Button>
                  </Form>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        )}

        {step === 3 && (
          <Row>
            <Col xs={12} sm={12} lg={12}>
              <Card>
                <Card.Body>
                  <Form>
                    <Row>
                      <Col>
                        <Card>
                          <Card.Header>Selected Widget</Card.Header>
                          <Card.Body>
                            <p>Selected Name: {widgetName}</p>
                            <p>Selected Description: {widgetDescription}</p>
                          </Card.Body>
                        </Card>
                      </Col>
                      <Col>
                        <Card>
                          <Card.Header>Selected Table & Chart Type</Card.Header>
                          <Card.Body>
                            <p>Selected Chart Type: {chartType}</p>
                            <p>Selected Table Name: {tableName}</p>
                          </Card.Body>
                        </Card>
                      </Col>
                    </Row>
                    <br />
                    {/* X-Axis Configuration */}
                    <Row>
                      {(chartType === "LINE" ||
                        chartType === "SPLINE" ||
                        chartType === "AREA" ||
                        chartType === "AREASPLINE" ||
                        chartType === "BAR" ||
                        chartType === "COLUMN" ||
                        chartType === "STACKEDBAR" ||
                        chartType === "STACKEDCOLUMN" ||
                        chartType === "GROUPEDBAR" ||
                        chartType === "STACKEDAREA" ||
                        chartType === "SCATTER" ||
                        chartType === "BUBBLE" ||
                        chartType === "FUNNEL" ||
                        chartType === "PYRAMID" ||
                        chartType === "WATERFALL" ||
                        chartType === "HEATMAP" ||
                        chartType === "BOXPLOT" ||
                        chartType === "ERRORBAR" ||
                        chartType === "COLUMNRANGE" ||
                        chartType === "AREARANGE" ||
                        chartType === "BARTARGET" ||
                        chartType === "MULTIBARTARGET" ||
                        chartType === "VARIABLERADIUSPIE" ||
                        chartType === "HISTOGRAM" ||
                        chartType === "BELLCURVE" ||
                        chartType === "PARETO" ||
                        chartType === "BULLET" ||
                        chartType === "LOLLIPOP" ||
                        chartType === "DUMBBELL" ||
                        chartType === "VARIWIDE" ||
                        chartType === "STREAMGRAPH" ||
                        chartType === "POLAR" ||
                        chartType === "RADIALBAR" ||
                        chartType === "SANKEY" ||
                        chartType === "DEPENDENCYWHEEL" ||
                        chartType === "ARCDIAGRAM" ||
                        chartType === "NETWORKGRAPH") && (
                        <Col>
                          <Card>
                            <Card.Body>
                              <h3>Select Column</h3>
                              <br />
                              <Row>
                                <Col xs={12} sm={6} md={4} lg={3}>
                                  <Form.Group controlId="xAxisColumn">
                                    <Form.Label>Select Column</Form.Label>
                                    <Form.Control
                                      as="select"
                                      // value={xAxisColumn}
                                      // onChange={(e) =>
                                      //   this.setState({ xAxisColumn: e.target.value })
                                      // }
                                      className="form-select"
                                      aria-label="Default select example"
                                      value={this.state.columnName}
                                      name="columnName"
                                      onChange={this.handleColumnChange}
                                    >
                                      <option value="">Column A</option>
                                      {this.state.columns.map((api, index) => (
                                        <option
                                          key={index}
                                          value={api.COLUMN_NAME}
                                        >
                                          {api.COLUMN_NAME}
                                        </option>
                                      ))}
                                    </Form.Control>
                                  </Form.Group>
                                </Col>
                                {/* <Col>
                                        <Form.Group controlId="yAxisColumn">
                                          <Form.Label>Select Column</Form.Label>
                                          <Form.Control
                                            as="select"
                                            className="form-select"
                                            aria-label="Default select example"
                                            value={this.state.columnName2}
                                            name="columnName2"
                                            onChange={this.handleColumnChange}
                                            //onChange={this.handleColumnOneChange}
                                          >
                                            <option value="">Column B</option>
                                            {this.state.columns.map((api, index) => (
                                              <option
                                                key={api.DATA_TYPE}
                                                value={api.COLUMN_NAME}
                                              >
                                                {api.COLUMN_NAME}
                                              </option>
                                            ))}
                                          </Form.Control>
                                        </Form.Group>
                                      </Col> */}
                                <Col lg="3">
                                  <Form.Group>
                                    <Form.Label>Aggregation</Form.Label>
                                    <Form.Control
                                      as="select"
                                      className="form-select"
                                      value={this.state.aggregation}
                                      onChange={
                                        this.handleAggregateColumnChange
                                      }
                                      name="aggregation"
                                    >
                                      <option value="">Select</option>
                                      <option value="count">Count</option>
                                      <option value="average">Average</option>
                                      <option value="sum">Sum</option>
                                    </Form.Control>
                                  </Form.Group>
                                </Col>
                              </Row>
                              <br />
                              <h3>Where condition</h3>
                              <br />
                              {this.state.rowscondition.map((row, index) => (
                                <div className="row">
                                  <div className="col">
                                    {" "}
                                    <Form.Group controlId="textBox">
                                      <Form.Label>Select Column</Form.Label>
                                      <Form.Control
                                        as="select"
                                        className="form-select"
                                        value={row.columnName || ""}
                                        name="columnName"
                                        //onChange={this.handleColumnChangeone}
                                        onChange={(e) =>
                                          this.handleColumnChangeone(index, e)
                                        }
                                      >
                                        <option value="">Select</option>
                                        {this.state.columns.map(
                                          (api, index) => (
                                            <option
                                              key={index}
                                              value={api.COLUMN_NAME}
                                            >
                                              {api.COLUMN_NAME}
                                            </option>
                                          ),
                                        )}
                                      </Form.Control>
                                    </Form.Group>
                                  </div>
                                  <div className="col">
                                    <Form.Group
                                      controlId={`columnvalueOperator-${index}`}
                                    >
                                      <Form.Label>Operator</Form.Label>
                                      <>
                                        {" "}
                                        {row.dataType === "int" && (
                                          <Form.Select
                                            className="form-select"
                                            name="columnvalueOperator"
                                            // onChange={
                                            //   this.handledataTypeOneChange
                                            // }
                                            onChange={(e) =>
                                              this.handleInputChange(index, e)
                                            }
                                            // value={
                                            //   this.state.columnvalueOperator
                                            // }
                                            value={
                                              row.columnvalueOperator || ""
                                            }
                                          >
                                            <option defaultValue>
                                              Operators{" "}
                                            </option>
                                            <option value="=">=</option>
                                            <option value="<">&lt;</option>
                                            <option value=">">&gt;</option>
                                            <option value="<=">&le;</option>
                                            <option value=">=">&ge;</option>
                                            <option value="!=">
                                              &ne; Not Equal
                                            </option>
                                            <option value="Is Empty">
                                              Is Empty
                                            </option>
                                            <option value="Is Not Empty">
                                              Is Not Empty
                                            </option>
                                          </Form.Select>
                                        )}
                                        {row.dataType === "varchar" && (
                                          <select
                                            className="form-select"
                                            name="columnvalueOperator"
                                            // onChange={
                                            //   this.handledataTypeOneChange
                                            // }
                                            onChange={(e) =>
                                              this.handleInputChange(index, e)
                                            }
                                            value={
                                              row.columnvalueOperator || ""
                                            }
                                          >
                                            <option>VarcharOperators</option>
                                            <option value="=">=</option>
                                            <option value="<">&lt;</option>
                                            <option value=">">&gt;</option>
                                            <option value="<=">&le;</option>
                                            <option value=">=">&ge;</option>
                                            <option value="!=">
                                              &ne; Not Equal
                                            </option>
                                            <option value="Is">Is</option>
                                            <option value="Isn't">Isn't</option>
                                            <option value="Contains">
                                              Contains
                                            </option>
                                            <option value="Doesn't Contains">
                                              Doesn't Contains
                                            </option>
                                            <option value="Starts With">
                                              Starts With
                                            </option>
                                            <option value="Ends With">
                                              Ends With
                                            </option>
                                            <option value="Is Empty">
                                              Is Empty
                                            </option>
                                            <option value="Is Not Empty">
                                              Is Not Empty
                                            </option>
                                          </select>
                                        )}
                                        {row.dataType === "text" && (
                                          <select
                                            className="form-select"
                                            value={
                                              row.columnvalueOperator || ""
                                            }
                                            // onChange={
                                            //   this.handledataTypeOneChange
                                            // }
                                            onChange={(e) =>
                                              this.handleInputChange(index, e)
                                            }
                                            name="columnvalueOperator"
                                          >
                                            <option defaultValue>
                                              textOperators
                                            </option>
                                            <option value="=">=</option>
                                            <option value="<">&lt;</option>
                                            <option value=">">&gt;</option>
                                            <option value="<=">&le;</option>
                                            <option value=">=">&ge;</option>
                                            <option value="!=">
                                              &ne; Not Equal
                                            </option>
                                            <option value="Is">Is</option>
                                            <option value="Isn't">Isn't</option>
                                            <option value="Contains">
                                              Contains
                                            </option>
                                            <option value="Doesn't Contains">
                                              Doesn't Contains
                                            </option>
                                            <option value="Is Before">
                                              Is Before
                                            </option>
                                            <option value="Is After">
                                              Is After
                                            </option>
                                            <option value="Starts With">
                                              Starts With
                                            </option>
                                            <option value="Ends With">
                                              Ends With
                                            </option>
                                            <option value="Is Empty">
                                              Is Empty
                                            </option>
                                            <option value="Is Not Empty">
                                              Is Not Empty
                                            </option>
                                          </select>
                                        )}
                                        {row.dataType === "datetime" && (
                                          <select
                                            className="form-select"
                                            value={
                                              row.columnvalueOperator || ""
                                            }
                                            // onChange={
                                            //   this.handledataTypeOneChange
                                            // }
                                            onChange={(e) =>
                                              this.handleInputChange(index, e)
                                            }
                                            name="columnvalueOperator"
                                          >
                                            <option defaultValue>
                                              textOperators
                                            </option>
                                            <option value="=">=</option>
                                            <option value="<">&lt;</option>
                                            <option value=">">&gt;</option>
                                            <option value="<=">&le;</option>
                                            <option value=">=">&ge;</option>
                                            <option value="!=">
                                              &ne; Not Equal
                                            </option>
                                            <option value="Before">
                                              Before
                                            </option>
                                            <option value="Between">
                                              Between
                                            </option>
                                            <option value="Starts With">
                                              Starts With
                                            </option>
                                            <option value="Ends With">
                                              Ends With
                                            </option>
                                            <option value="Year">Year</option>
                                            <option value="Month">Month</option>
                                          </select>
                                        )}
                                        {row.dataType === "date" && (
                                          <select
                                            className="form-select"
                                            value={
                                              row.columnvalueOperator || ""
                                            }
                                            // onChange={
                                            //   this.handledataTypeOneChange
                                            // }
                                            onChange={(e) =>
                                              this.handleInputChange(index, e)
                                            }
                                            name="columnvalueOperator"
                                          >
                                            <option defaultValue>
                                              textOperators
                                            </option>
                                            <option value="=">=</option>
                                            <option value="<">&lt;</option>
                                            <option value=">">&gt;</option>
                                            <option value="<=">&le;</option>
                                            <option value=">=">&ge;</option>
                                            <option value="!=">
                                              &ne; Not Equal
                                            </option>
                                            <option value="Today">Today</option>
                                            <option value="Yesterday">
                                              Yesterday
                                            </option>
                                            <option value="Tomorrow">
                                              Tomorrow
                                            </option>
                                            <option value="Last N Days">
                                              Last N Days
                                            </option>
                                            <option value="Next N Days">
                                              Next N Days
                                            </option>
                                            <option value="Before">
                                              Before
                                            </option>
                                            <option value="Between">
                                              Between
                                            </option>
                                            <option value="Starts With">
                                              Starts With
                                            </option>
                                            <option value="Ends With">
                                              Ends With
                                            </option>
                                            <option value="Current Month">
                                              Current Month
                                            </option>
                                            <option value="Current Year">
                                              Current Year
                                            </option>
                                            <option value="Year">Year</option>
                                            <option value="Month">Month</option>
                                          </select>
                                        )}
                                        {row.dataType === "timestamp" && (
                                          <select
                                            className="form-select"
                                            value={
                                              row.columnvalueOperator || ""
                                            }
                                            // onChange={
                                            //   this.handledataTypeOneChange
                                            // }
                                            onChange={(e) =>
                                              this.handleInputChange(index, e)
                                            }
                                            name="columnvalueOperator"
                                          >
                                            <option defaultValue>
                                              textOperators
                                            </option>
                                            <option value="=">=</option>
                                            <option value="<">&lt;</option>
                                            <option value=">">&gt;</option>
                                            <option value="<=">&le;</option>
                                            <option value=">=">&ge;</option>
                                            <option value="!=">
                                              &ne; Not Equal
                                            </option>
                                            <option value="Today">Today</option>
                                            <option value="Yesterday">
                                              Yesterday
                                            </option>
                                            <option value="Tomorrow">
                                              Tomorrow
                                            </option>
                                            <option value="Last N Days">
                                              Last N Days
                                            </option>
                                            <option value="Next N Days">
                                              Next N Days
                                            </option>
                                            <option value="Before">
                                              Before
                                            </option>
                                            <option value="Between">
                                              Between
                                            </option>
                                            <option value="Starts With">
                                              Starts With
                                            </option>
                                            <option value="Ends With">
                                              Ends With
                                            </option>
                                            <option value="Current Month">
                                              Current Month
                                            </option>
                                            <option value="Current Year">
                                              Current Year
                                            </option>
                                            <option value="Year">Year</option>
                                            <option value="Month">Month</option>
                                          </select>
                                        )}
                                      </>
                                    </Form.Group>
                                  </div>

                                  <div className="col">
                                    {this.renderConditionValueInput(index, row)}
                                  </div>
                                  <div className="col">
                                    {" "}
                                    <Form.Group controlId="textBox">
                                      <Form.Label>Logical Operators</Form.Label>
                                      <Form.Control
                                        as="select"
                                        className="form-select"
                                        value={row.logicalOperator}
                                        onChange={(e) =>
                                          this.handleInputChange(index, e)
                                        }
                                        // value={this.state.logicalOperator}
                                        // onChange={
                                        //   this.handlelogicalOperatorChange
                                        // }
                                        name="logicalOperator"
                                      >
                                        <option value="">Select</option>
                                        <option value="AND">AND</option>
                                        <option value="OR">OR</option>
                                        <option value="NOT">NOT</option>
                                      </Form.Control>
                                    </Form.Group>
                                  </div>
                                  <div className="col-1">
                                    {index === 0 ? (
                                      row.logicalOperator ? (
                                        <Button
                                          onClick={this.handleAddRow}
                                          style={{ marginTop: "30px" }}
                                          className="bi bi-plus"
                                        ></Button>
                                      ) : null
                                    ) : (
                                      <Button
                                        onClick={() =>
                                          this.handleRemoveRow(index)
                                        }
                                        style={{ marginTop: "30px" }}
                                        className="bi bi-trash"
                                      ></Button>
                                    )}
                                  </div>
                                </div>
                              ))}
                              <div className="row">
                                <div className="col">
                                  {" "}
                                  <Form.Group controlId="textBox">
                                    <Form.Label>Group By Column</Form.Label>
                                    <Form.Control
                                      as="select"
                                      className="form-select"
                                      value={this.state.groupbyColumn}
                                      onChange={this.handlegroupbyColumnChange}
                                      name="groupbyColumn"
                                    >
                                      <option value="">Select</option>
                                      {this.state.columns.map((api, index) => (
                                        <option
                                          key={index}
                                          value={api.COLUMN_NAME}
                                        >
                                          {api.COLUMN_NAME}
                                        </option>
                                      ))}
                                    </Form.Control>
                                  </Form.Group>
                                </div>
                                <div className="col">
                                  {" "}
                                  <Form.Group>
                                    <Form.Label>Group By</Form.Label>
                                    {this.state.groupbyColumnType === "date" ||
                                    this.state.groupbyColumnType ===
                                      "timestamp" ? (
                                      <Form.Select
                                        className="form-select"
                                        name="extractMonth"
                                        value={this.state.extractMonth}
                                        onChange={this.handleExactmonthChange}
                                      >
                                        <option value="">Select</option>
                                        <option value="MY">Month & Year</option>
                                        <option value="Y">Year</option>
                                        <option value="M">Month</option>
                                      </Form.Select>
                                    ) : (
                                      <p className="mt-2">
                                        No operators available for this type
                                      </p>
                                    )}
                                  </Form.Group>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col">
                                  {" "}
                                  <Form.Group controlId="textBox">
                                    <Form.Label>Drilldown Where</Form.Label>
                                    <Form.Control
                                      as="select"
                                      className="form-select"
                                      value={this.state.drilldownWhere}
                                      onChange={this.handlewheredrilldownChange}
                                      name="drilldownWhere"
                                    >
                                      <option value="">Select</option>
                                      {this.state.columns.map((api, index) => (
                                        <option
                                          key={index}
                                          value={api.COLUMN_NAME}
                                        >
                                          {api.COLUMN_NAME}
                                        </option>
                                      ))}
                                    </Form.Control>
                                  </Form.Group>
                                </div>
                                <div className="col">
                                  {" "}
                                  <Form.Group>
                                    <Form.Label>Operator</Form.Label>
                                    <Form.Select
                                      className="form-select"
                                      name="columnvalueOperator"
                                      onChange={this.handlevalueOperatorChange}
                                      value={this.state.valueOperator}
                                    >
                                      <option defaultValue>Operators </option>
                                      <option value="=">=</option>
                                      <option value="<">&lt;</option>
                                      <option value=">">&gt;</option>
                                      <option value="<=">&le;</option>
                                      <option value=">=">&ge;</option>
                                      <option value="!=">&ne; Not Equal</option>
                                      <option value="Is Empty">Is Empty</option>
                                      <option value="Is Not Empty">
                                        Is Not Empty
                                      </option>
                                    </Form.Select>
                                  </Form.Group>
                                </div>
                                <div className="col">
                                  {" "}
                                  <Form.Group>
                                    <Form.Label>Value</Form.Label>
                                    <Form.Control
                                      type="text"
                                      onChange={
                                        this.handleddrilldownvalueChange
                                      }
                                      className="form-control"
                                      name="drilldownvalue"
                                      value={this.state.drilldownvalue}
                                      placeholder="Enter Value"
                                    />
                                  </Form.Group>
                                </div>
                                <div className="col">
                                  {" "}
                                  <Form.Group>
                                    <Form.Label>Drilldown Group By</Form.Label>
                                    <Form.Control
                                      as="select"
                                      className="form-select"
                                      value={this.state.drilldownGroupby}
                                      onChange={this.handlegroupbyChange}
                                      name="drilldownGroupby"
                                    >
                                      <option value="">Select</option>
                                      {this.state.columns.map((api, index) => (
                                        <option
                                          key={index}
                                          value={api.COLUMN_NAME}
                                        >
                                          {api.COLUMN_NAME}
                                        </option>
                                      ))}
                                    </Form.Control>
                                  </Form.Group>
                                </div>
                                <div className="col">
                                  <Form.Group controlId="textBox">
                                    <Form.Label>Source report id</Form.Label>
                                    <Form.Control
                                      type="text"
                                      name="sourcereportId"
                                      value={this.state.sourcereportId}
                                      placeholder="Widget Name"
                                      onChange={(e) =>
                                        this.setState({
                                          sourcereportId: e.target.value,
                                        })
                                      }
                                    />
                                  </Form.Group>
                                </div>
                                <div className="col">
                                  <Form.Group controlId="textBox">
                                    <Form.Label>
                                      Destination report id
                                    </Form.Label>
                                    <Form.Control
                                      type="text"
                                      name="destinationreportId"
                                      value={this.state.destinationreportId}
                                      placeholder="Widget Name"
                                      onChange={(e) =>
                                        this.setState({
                                          destinationreportId: e.target.value,
                                        })
                                      }
                                    />
                                  </Form.Group>
                                </div>
                                <div className="col">
                                  <Form.Group controlId="textBox">
                                    <Form.Label>Employee Column</Form.Label>
                                    <select
                                      className="form-select"
                                      name="employeeColumn"
                                      value={this.state.employeeColumn}
                                      placeholder="Enter Employee Column"
                                      onChange={(e) =>
                                        this.setState({
                                          employeeColumn: e.target.value,
                                        })
                                      }
                                    >
                                      <option defaultValue>
                                        Select Employee
                                      </option>
                                      {this.state.columns.map((api, index) => (
                                        <option
                                          key={index}
                                          value={api.COLUMN_NAME}
                                        >
                                          {api.COLUMN_NAME}
                                        </option>
                                      ))}
                                    </select>
                                  </Form.Group>
                                </div>
                              </div>
                            </Card.Body>
                          </Card>
                        </Col>
                      )}

                      {/* Display only one column selector for Pie chart */}
                      {(chartType === "PIE" ||
                        chartType === "DONUT" ||
                        chartType === "GAUGE" ||
                        chartType === "SOLIDGAUGE" ||
                        chartType === "SUNBURST" ||
                        chartType === "TREEMAP" ||
                        chartType === "WORDCLOUD" ||
                        chartType === "PACKEDBUBBLE" ||
                        chartType === "ITEM" ||
                        chartType === "PICTORIAL" ||
                        chartType === "VENN") && (
                        <Col>
                          <Card>
                            <Card.Body>
                              <h3>Select </h3>
                              <br />
                              <Row>
                                <Col lg="3">
                                  {" "}
                                  <Form.Group controlId="xAxisColumn">
                                    <Form.Label>Select Column</Form.Label>
                                    <Form.Control
                                      as="select"
                                      // value={xAxisColumn}
                                      // onChange={(e) =>
                                      //   this.setState({ xAxisColumn: e.target.value })
                                      // }
                                      className="form-select"
                                      aria-label="Default select example"
                                      value={this.state.columnName}
                                      name="columnName"
                                      onChange={this.handleColumnChange}
                                    >
                                      <option value="">Column A</option>
                                      {this.state.columns.map((api, index) => (
                                        <option
                                          key={index}
                                          value={api.COLUMN_NAME}
                                        >
                                          {api.COLUMN_NAME}
                                        </option>
                                      ))}
                                    </Form.Control>
                                  </Form.Group>
                                </Col>
                                <Col lg="3">
                                  <Form.Group>
                                    <Form.Label>Aggregation</Form.Label>
                                    <Form.Control
                                      as="select"
                                      className="form-select"
                                      value={this.state.aggregation}
                                      onChange={
                                        this.handleAggregateColumnChange
                                      }
                                      name="aggregation"
                                    >
                                      <option value="">Select</option>
                                      <option value="count">Count</option>
                                      <option value="average">Average</option>
                                      <option value="sum">Sum</option>
                                    </Form.Control>
                                  </Form.Group>
                                </Col>
                              </Row>
                              <br />
                              <h3>Where condition</h3>
                              <br />
                              {this.state.rowscondition.map((row, index) => (
                                <div className="row">
                                  <div className="col">
                                    {" "}
                                    <Form.Group controlId="textBox">
                                      <Form.Label>Select Column</Form.Label>
                                      <Form.Control
                                        as="select"
                                        className="form-select"
                                        value={row.columnName || ""}
                                        name="columnName"
                                        //onChange={this.handleColumnChangeone}
                                        onChange={(e) =>
                                          this.handleColumnChangeone(index, e)
                                        }
                                      >
                                        <option value="">Select</option>
                                        {this.state.columns.map(
                                          (api, index) => (
                                            <option
                                              key={index}
                                              value={api.COLUMN_NAME}
                                            >
                                              {api.COLUMN_NAME}
                                            </option>
                                          ),
                                        )}
                                      </Form.Control>
                                    </Form.Group>
                                  </div>
                                  <div className="col">
                                    <Form.Group
                                      controlId={`columnvalueOperator-${index}`}
                                    >
                                      <Form.Label>Operator</Form.Label>
                                      <>
                                        {" "}
                                        {row.dataType === "int" && (
                                          <Form.Select
                                            className="form-select"
                                            name="columnvalueOperator"
                                            // onChange={
                                            //   this.handledataTypeOneChange
                                            // }
                                            onChange={(e) =>
                                              this.handleInputChange(index, e)
                                            }
                                            // value={
                                            //   this.state.columnvalueOperator
                                            // }
                                            value={
                                              row.columnvalueOperator || ""
                                            }
                                          >
                                            <option defaultValue>
                                              Operators{" "}
                                            </option>
                                            <option value="=">=</option>
                                            <option value="<">&lt;</option>
                                            <option value=">">&gt;</option>
                                            <option value="<=">&le;</option>
                                            <option value=">=">&ge;</option>
                                            <option value="!=">
                                              &ne; Not Equal
                                            </option>
                                            <option value="Is Empty">
                                              Is Empty
                                            </option>
                                            <option value="Is Not Empty">
                                              Is Not Empty
                                            </option>
                                          </Form.Select>
                                        )}
                                        {row.dataType === "varchar" && (
                                          <select
                                            className="form-select"
                                            name="columnvalueOperator"
                                            // onChange={
                                            //   this.handledataTypeOneChange
                                            // }
                                            onChange={(e) =>
                                              this.handleInputChange(index, e)
                                            }
                                            value={
                                              row.columnvalueOperator || ""
                                            }
                                          >
                                            <option>VarcharOperators</option>
                                            <option value="=">=</option>
                                            <option value="<">&lt;</option>
                                            <option value=">">&gt;</option>
                                            <option value="<=">&le;</option>
                                            <option value=">=">&ge;</option>
                                            <option value="!=">
                                              &ne; Not Equal
                                            </option>
                                            <option value="Is">Is</option>
                                            <option value="Isn't">Isn't</option>
                                            <option value="Contains">
                                              Contains
                                            </option>
                                            <option value="Doesn't Contains">
                                              Doesn't Contains
                                            </option>
                                            <option value="Starts With">
                                              Starts With
                                            </option>
                                            <option value="Ends With">
                                              Ends With
                                            </option>
                                            <option value="Is Empty">
                                              Is Empty
                                            </option>
                                            <option value="Is Not Empty">
                                              Is Not Empty
                                            </option>
                                          </select>
                                        )}
                                        {row.dataType === "text" && (
                                          <select
                                            className="form-select"
                                            value={
                                              row.columnvalueOperator || ""
                                            }
                                            // onChange={
                                            //   this.handledataTypeOneChange
                                            // }
                                            onChange={(e) =>
                                              this.handleInputChange(index, e)
                                            }
                                            name="columnvalueOperator"
                                          >
                                            <option defaultValue>
                                              textOperators
                                            </option>
                                            <option value="=">=</option>
                                            <option value="<">&lt;</option>
                                            <option value=">">&gt;</option>
                                            <option value="<=">&le;</option>
                                            <option value=">=">&ge;</option>
                                            <option value="!=">
                                              &ne; Not Equal
                                            </option>
                                            <option value="Is">Is</option>
                                            <option value="Isn't">Isn't</option>
                                            <option value="Contains">
                                              Contains
                                            </option>
                                            <option value="Doesn't Contains">
                                              Doesn't Contains
                                            </option>
                                            <option value="Is Before">
                                              Is Before
                                            </option>
                                            <option value="Is After">
                                              Is After
                                            </option>
                                            <option value="Starts With">
                                              Starts With
                                            </option>
                                            <option value="Ends With">
                                              Ends With
                                            </option>
                                            <option value="Is Empty">
                                              Is Empty
                                            </option>
                                            <option value="Is Not Empty">
                                              Is Not Empty
                                            </option>
                                          </select>
                                        )}
                                        {row.dataType === "datetime" && (
                                          <select
                                            className="form-select"
                                            value={
                                              row.columnvalueOperator || ""
                                            }
                                            // onChange={
                                            //   this.handledataTypeOneChange
                                            // }
                                            onChange={(e) =>
                                              this.handleInputChange(index, e)
                                            }
                                            name="columnvalueOperator"
                                          >
                                            <option defaultValue>
                                              textOperators
                                            </option>
                                            <option value="=">=</option>
                                            <option value="<">&lt;</option>
                                            <option value=">">&gt;</option>
                                            <option value="<=">&le;</option>
                                            <option value=">=">&ge;</option>
                                            <option value="!=">
                                              &ne; Not Equal
                                            </option>
                                            <option value="Before">
                                              Before
                                            </option>
                                            <option value="Between">
                                              Between
                                            </option>
                                            <option value="Starts With">
                                              Starts With
                                            </option>
                                            <option value="Ends With">
                                              Ends With
                                            </option>
                                            <option value="Year">Year</option>
                                            <option value="Month">Month</option>
                                          </select>
                                        )}
                                        {row.dataType === "date" && (
                                          <select
                                            className="form-select"
                                            value={
                                              row.columnvalueOperator || ""
                                            }
                                            // onChange={
                                            //   this.handledataTypeOneChange
                                            // }
                                            onChange={(e) =>
                                              this.handleInputChange(index, e)
                                            }
                                            name="columnvalueOperator"
                                          >
                                            <option defaultValue>
                                              textOperators
                                            </option>
                                            <option value="=">=</option>
                                            <option value="<">&lt;</option>
                                            <option value=">">&gt;</option>
                                            <option value="<=">&le;</option>
                                            <option value=">=">&ge;</option>
                                            <option value="!=">
                                              &ne; Not Equal
                                            </option>
                                            <option value="Today">Today</option>
                                            <option value="Yesterday">
                                              Yesterday
                                            </option>
                                            <option value="Tomorrow">
                                              Tomorrow
                                            </option>
                                            <option value="Last N Days">
                                              Last N Days
                                            </option>
                                            <option value="Next N Days">
                                              Next N Days
                                            </option>
                                            <option value="Before">
                                              Before
                                            </option>
                                            <option value="Between">
                                              Between
                                            </option>
                                            <option value="Starts With">
                                              Starts With
                                            </option>
                                            <option value="Ends With">
                                              Ends With
                                            </option>
                                            <option value="Current Month">
                                              Current Month
                                            </option>
                                            <option value="Current Year">
                                              Current Year
                                            </option>
                                            <option value="Year">Year</option>
                                            <option value="Month">Month</option>
                                          </select>
                                        )}
                                        {row.dataType === "timestamp" && (
                                          <select
                                            className="form-select"
                                            value={
                                              row.columnvalueOperator || ""
                                            }
                                            // onChange={
                                            //   this.handledataTypeOneChange
                                            // }
                                            onChange={(e) =>
                                              this.handleInputChange(index, e)
                                            }
                                            name="columnvalueOperator"
                                          >
                                            <option defaultValue>
                                              textOperators
                                            </option>
                                            <option value="=">=</option>
                                            <option value="<">&lt;</option>
                                            <option value=">">&gt;</option>
                                            <option value="<=">&le;</option>
                                            <option value=">=">&ge;</option>
                                            <option value="!=">
                                              &ne; Not Equal
                                            </option>
                                            <option value="Today">Today</option>
                                            <option value="Yesterday">
                                              Yesterday
                                            </option>
                                            <option value="Tomorrow">
                                              Tomorrow
                                            </option>
                                            <option value="Last N Days">
                                              Last N Days
                                            </option>
                                            <option value="Next N Days">
                                              Next N Days
                                            </option>
                                            <option value="Before">
                                              Before
                                            </option>
                                            <option value="Between">
                                              Between
                                            </option>
                                            <option value="Starts With">
                                              Starts With
                                            </option>
                                            <option value="Ends With">
                                              Ends With
                                            </option>
                                            <option value="Current Month">
                                              Current Month
                                            </option>
                                            <option value="Current Year">
                                              Current Year
                                            </option>
                                            <option value="Year">Year</option>
                                            <option value="Month">Month</option>
                                          </select>
                                        )}
                                      </>
                                    </Form.Group>
                                  </div>

                                  <div className="col">
                                    {this.renderConditionValueInput(index, row)}
                                  </div>
                                  <div className="col">
                                    {" "}
                                    <Form.Group controlId="textBox">
                                      <Form.Label>Logical Operators</Form.Label>
                                      <Form.Control
                                        as="select"
                                        className="form-select"
                                        value={row.logicalOperator}
                                        onChange={(e) =>
                                          this.handleInputChange(index, e)
                                        }
                                        // value={this.state.logicalOperator}
                                        // onChange={
                                        //   this.handlelogicalOperatorChange
                                        // }
                                        name="logicalOperator"
                                      >
                                        <option value="">Select</option>
                                        <option value="AND">AND</option>
                                        <option value="OR">OR</option>
                                        <option value="NOT">NOT</option>
                                      </Form.Control>
                                    </Form.Group>
                                  </div>
                                  <div className="col">
                                    {index === 0 ? (
                                      row.logicalOperator ? (
                                        <Button
                                          onClick={this.handleAddRow}
                                          style={{ marginTop: "30px" }}
                                          className="bi bi-plus"
                                        ></Button>
                                      ) : null
                                    ) : (
                                      <Button
                                        onClick={() =>
                                          this.handleRemoveRow(index)
                                        }
                                        style={{ marginTop: "30px" }}
                                        className="bi bi-trash"
                                      ></Button>
                                    )}
                                  </div>
                                </div>
                              ))}
                              <div className="row">
                                <div className="col">
                                  {" "}
                                  <Form.Group controlId="textBox">
                                    <Form.Label>Group By Column</Form.Label>
                                    <Form.Control
                                      as="select"
                                      className="form-select"
                                      value={this.state.groupbyColumn}
                                      onChange={this.handlegroupbyColumnChange}
                                      name="groupbyColumn"
                                    >
                                      <option value="">Select</option>
                                      {this.state.columns.map((api, index) => (
                                        <option
                                          key={index}
                                          value={api.COLUMN_NAME}
                                        >
                                          {api.COLUMN_NAME}
                                        </option>
                                      ))}
                                    </Form.Control>
                                  </Form.Group>
                                </div>
                                <div className="col">
                                  {" "}
                                  <Form.Group>
                                    <Form.Label>Group By</Form.Label>
                                    {this.state.groupbyColumnType === "date" ||
                                    this.state.groupbyColumnType ===
                                      "timestamp" ? (
                                      <Form.Select
                                        className="form-select"
                                        name="extractMonth"
                                        value={this.state.extractMonth}
                                        onChange={this.handleExactmonthChange}
                                      >
                                        <option value="">Select</option>
                                        <option value="MY">Month & Year</option>
                                        <option value="Y">Year</option>
                                        <option value="M">Month</option>
                                      </Form.Select>
                                    ) : (
                                      <p className="mt-2">
                                        No operators available for this type
                                      </p>
                                    )}
                                  </Form.Group>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col">
                                  {" "}
                                  <Form.Group controlId="textBox">
                                    <Form.Label>Drilldown Where</Form.Label>
                                    <Form.Control
                                      as="select"
                                      className="form-select"
                                      value={this.state.drilldownWhere}
                                      onChange={this.handlewheredrilldownChange}
                                      name="drilldownWhere"
                                    >
                                      <option value="">Select</option>
                                      {this.state.columns.map((api, index) => (
                                        <option
                                          key={index}
                                          value={api.COLUMN_NAME}
                                        >
                                          {api.COLUMN_NAME}
                                        </option>
                                      ))}
                                    </Form.Control>
                                  </Form.Group>
                                </div>
                                <div className="col">
                                  {" "}
                                  <Form.Group>
                                    <Form.Label>Operator</Form.Label>
                                    <Form.Select
                                      className="form-select"
                                      name="columnvalueOperator"
                                      onChange={this.handlevalueOperatorChange}
                                      value={this.state.valueOperator}
                                    >
                                      <option defaultValue>Operators </option>
                                      <option value="=">=</option>
                                      <option value="<">&lt;</option>
                                      <option value=">">&gt;</option>
                                      <option value="<=">&le;</option>
                                      <option value=">=">&ge;</option>
                                      <option value="!=">&ne; Not Equal</option>
                                      <option value="Is Empty">Is Empty</option>
                                      <option value="Is Not Empty">
                                        Is Not Empty
                                      </option>
                                    </Form.Select>
                                  </Form.Group>
                                </div>
                                <div className="col">
                                  {" "}
                                  <Form.Group>
                                    <Form.Label>Value</Form.Label>
                                    <Form.Control
                                      type="text"
                                      onChange={
                                        this.handleddrilldownvalueChange
                                      }
                                      className="form-control"
                                      name="drilldownvalue"
                                      value={this.state.drilldownvalue}
                                      placeholder="Enter Value"
                                    />
                                  </Form.Group>
                                </div>
                                <div className="col">
                                  {" "}
                                  <Form.Group>
                                    <Form.Label>Drilldown Group By</Form.Label>
                                    <Form.Control
                                      as="select"
                                      className="form-select"
                                      value={this.state.drilldownGroupby}
                                      onChange={this.handlegroupbyChange}
                                      name="drilldownGroupby"
                                    >
                                      <option value="">Select</option>
                                      {this.state.columns.map((api, index) => (
                                        <option
                                          key={index}
                                          value={api.COLUMN_NAME}
                                        >
                                          {api.COLUMN_NAME}
                                        </option>
                                      ))}
                                    </Form.Control>
                                  </Form.Group>
                                </div>
                                <div className="col">
                                  <Form.Group controlId="textBox">
                                    <Form.Label>Source report id</Form.Label>
                                    <Form.Control
                                      type="text"
                                      name="sourcereportId"
                                      value={this.state.sourcereportId}
                                      placeholder="Widget Name"
                                      onChange={(e) =>
                                        this.setState({
                                          sourcereportId: e.target.value,
                                        })
                                      }
                                    />
                                  </Form.Group>
                                </div>
                                <div className="col">
                                  <Form.Group controlId="textBox">
                                    <Form.Label>
                                      Destination report id
                                    </Form.Label>
                                    <Form.Control
                                      type="text"
                                      name="destinationreportId"
                                      value={this.state.destinationreportId}
                                      placeholder="Widget Name"
                                      onChange={(e) =>
                                        this.setState({
                                          destinationreportId: e.target.value,
                                        })
                                      }
                                    />
                                  </Form.Group>
                                </div>
                                <div className="col">
                                  <Form.Group controlId="textBox">
                                    <Form.Label>Employee Column</Form.Label>
                                    <select
                                      className="form-select"
                                      name="employeeColumn"
                                      value={this.state.employeeColumn}
                                      placeholder="Enter Employee Column"
                                      onChange={(e) =>
                                        this.setState({
                                          employeeColumn: e.target.value,
                                        })
                                      }
                                    >
                                      <option defaultValue>
                                        Select Employee
                                      </option>
                                      {this.state.columns.map((api, index) => (
                                        <option
                                          key={index}
                                          value={api.COLUMN_NAME}
                                        >
                                          {api.COLUMN_NAME}
                                        </option>
                                      ))}
                                    </select>
                                  </Form.Group>
                                </div>
                              </div>
                            </Card.Body>
                          </Card>
                        </Col>
                      )}
                      {/*BISCUIT*/}
                      {chartType === "BISCUIT" && (
                        <Col>
                          <Card>
                            <Card.Body>
                              <h3>Select </h3>
                              <br />
                              <Row>
                                <Col lg="3">
                                  {" "}
                                  <Form.Group controlId="xAxisColumn">
                                    <Form.Label>Select Column</Form.Label>
                                    <Form.Control
                                      as="select"
                                      // value={xAxisColumn}
                                      // onChange={(e) =>
                                      //   this.setState({ xAxisColumn: e.target.value })
                                      // }
                                      className="form-select"
                                      aria-label="Default select example"
                                      value={this.state.columnName}
                                      name="columnName"
                                      onChange={this.handleColumnChange}
                                    >
                                      <option value="">Column A</option>
                                      {this.state.columns.map((api, index) => (
                                        <option
                                          key={index}
                                          value={api.COLUMN_NAME}
                                        >
                                          {api.COLUMN_NAME}
                                        </option>
                                      ))}
                                    </Form.Control>
                                  </Form.Group>
                                </Col>

                                <Col lg="3">
                                  <Form.Group>
                                    <Form.Label>Aggregation</Form.Label>
                                    <Form.Control
                                      as="select"
                                      className="form-select"
                                      value={this.state.aggregation}
                                      onChange={
                                        this.handleAggregateColumnChange
                                      }
                                      name="aggregation"
                                    >
                                      <option value="">Select</option>
                                      <option value="count">Count</option>
                                      <option value="average">Average</option>
                                      <option value="sum">Sum</option>
                                    </Form.Control>
                                  </Form.Group>
                                </Col>
                              </Row>
                              <br />
                              <h3>Where condition</h3>
                              <br />
                              {this.state.rowscondition.map((row, index) => (
                                <div className="row">
                                  <div className="col">
                                    {" "}
                                    <Form.Group controlId="textBox">
                                      <Form.Label>Select Column</Form.Label>
                                      <Form.Control
                                        as="select"
                                        className="form-select"
                                        value={row.columnName || ""}
                                        name="columnName"
                                        //onChange={this.handleColumnChangeone}
                                        onChange={(e) =>
                                          this.handleColumnChangeone(index, e)
                                        }
                                      >
                                        <option value="">Select</option>
                                        {this.state.columns.map(
                                          (api, index) => (
                                            <option
                                              key={index}
                                              value={api.COLUMN_NAME}
                                            >
                                              {api.COLUMN_NAME}
                                            </option>
                                          ),
                                        )}
                                      </Form.Control>
                                    </Form.Group>
                                  </div>
                                  <div className="col">
                                    <Form.Group
                                      controlId={`columnvalueOperator-${index}`}
                                    >
                                      <Form.Label>Operator</Form.Label>
                                      <>
                                        {" "}
                                        {row.dataType === "int" && (
                                          <Form.Select
                                            className="form-select"
                                            name="columnvalueOperator"
                                            // onChange={
                                            //   this.handledataTypeOneChange
                                            // }
                                            onChange={(e) =>
                                              this.handleInputChange(index, e)
                                            }
                                            // value={
                                            //   this.state.columnvalueOperator
                                            // }
                                            value={
                                              row.columnvalueOperator || ""
                                            }
                                          >
                                            <option defaultValue>
                                              Operators{" "}
                                            </option>
                                            <option value="=">=</option>
                                            <option value="<">&lt;</option>
                                            <option value=">">&gt;</option>
                                            <option value="<=">&le;</option>
                                            <option value=">=">&ge;</option>
                                            <option value="!=">
                                              &ne; Not Equal
                                            </option>
                                            <option value="Is Empty">
                                              Is Empty
                                            </option>
                                            <option value="Is Not Empty">
                                              Is Not Empty
                                            </option>
                                          </Form.Select>
                                        )}
                                        {row.dataType === "varchar" && (
                                          <select
                                            className="form-select"
                                            name="columnvalueOperator"
                                            // onChange={
                                            //   this.handledataTypeOneChange
                                            // }
                                            onChange={(e) =>
                                              this.handleInputChange(index, e)
                                            }
                                            value={
                                              row.columnvalueOperator || ""
                                            }
                                          >
                                            <option>VarcharOperators</option>
                                            <option value="=">=</option>
                                            <option value="<">&lt;</option>
                                            <option value=">">&gt;</option>
                                            <option value="<=">&le;</option>
                                            <option value=">=">&ge;</option>
                                            <option value="!=">
                                              &ne; Not Equal
                                            </option>
                                            <option value="Is">Is</option>
                                            <option value="Isn't">Isn't</option>
                                            <option value="Contains">
                                              Contains
                                            </option>
                                            <option value="Doesn't Contains">
                                              Doesn't Contains
                                            </option>
                                            <option value="Starts With">
                                              Starts With
                                            </option>
                                            <option value="Ends With">
                                              Ends With
                                            </option>
                                            <option value="Is Empty">
                                              Is Empty
                                            </option>
                                            <option value="Is Not Empty">
                                              Is Not Empty
                                            </option>
                                          </select>
                                        )}
                                        {row.dataType === "text" && (
                                          <select
                                            className="form-select"
                                            value={
                                              row.columnvalueOperator || ""
                                            }
                                            // onChange={
                                            //   this.handledataTypeOneChange
                                            // }
                                            onChange={(e) =>
                                              this.handleInputChange(index, e)
                                            }
                                            name="columnvalueOperator"
                                          >
                                            <option defaultValue>
                                              textOperators
                                            </option>
                                            <option value="=">=</option>
                                            <option value="<">&lt;</option>
                                            <option value=">">&gt;</option>
                                            <option value="<=">&le;</option>
                                            <option value=">=">&ge;</option>
                                            <option value="!=">
                                              &ne; Not Equal
                                            </option>
                                            <option value="Is">Is</option>
                                            <option value="Isn't">Isn't</option>
                                            <option value="Contains">
                                              Contains
                                            </option>
                                            <option value="Doesn't Contains">
                                              Doesn't Contains
                                            </option>
                                            <option value="Is Before">
                                              Is Before
                                            </option>
                                            <option value="Is After">
                                              Is After
                                            </option>
                                            <option value="Starts With">
                                              Starts With
                                            </option>
                                            <option value="Ends With">
                                              Ends With
                                            </option>
                                            <option value="Is Empty">
                                              Is Empty
                                            </option>
                                            <option value="Is Not Empty">
                                              Is Not Empty
                                            </option>
                                          </select>
                                        )}
                                        {row.dataType === "datetime" && (
                                          <select
                                            className="form-select"
                                            value={
                                              row.columnvalueOperator || ""
                                            }
                                            // onChange={
                                            //   this.handledataTypeOneChange
                                            // }
                                            onChange={(e) =>
                                              this.handleInputChange(index, e)
                                            }
                                            name="columnvalueOperator"
                                          >
                                            <option defaultValue>
                                              textOperators
                                            </option>
                                            <option value="=">=</option>
                                            <option value="<">&lt;</option>
                                            <option value=">">&gt;</option>
                                            <option value="<=">&le;</option>
                                            <option value=">=">&ge;</option>
                                            <option value="!=">
                                              &ne; Not Equal
                                            </option>
                                            <option value="Before">
                                              Before
                                            </option>
                                            <option value="Between">
                                              Between
                                            </option>
                                            <option value="Starts With">
                                              Starts With
                                            </option>
                                            <option value="Ends With">
                                              Ends With
                                            </option>
                                            <option value="Year">Year</option>
                                            <option value="Month">Month</option>
                                          </select>
                                        )}
                                        {row.dataType === "date" && (
                                          <select
                                            className="form-select"
                                            value={
                                              row.columnvalueOperator || ""
                                            }
                                            // onChange={
                                            //   this.handledataTypeOneChange
                                            // }
                                            onChange={(e) =>
                                              this.handleInputChange(index, e)
                                            }
                                            name="columnvalueOperator"
                                          >
                                            <option defaultValue>
                                              textOperators
                                            </option>
                                            <option value="=">=</option>
                                            <option value="<">&lt;</option>
                                            <option value=">">&gt;</option>
                                            <option value="<=">&le;</option>
                                            <option value=">=">&ge;</option>
                                            <option value="!=">
                                              &ne; Not Equal
                                            </option>
                                            <option value="Today">Today</option>
                                            <option value="Yesterday">
                                              Yesterday
                                            </option>
                                            <option value="Tomorrow">
                                              Tomorrow
                                            </option>
                                            <option value="Last N Days">
                                              Last N Days
                                            </option>
                                            <option value="Next N Days">
                                              Next N Days
                                            </option>
                                            <option value="Before">
                                              Before
                                            </option>
                                            <option value="Between">
                                              Between
                                            </option>
                                            <option value="Starts With">
                                              Starts With
                                            </option>
                                            <option value="Ends With">
                                              Ends With
                                            </option>
                                            <option value="Current Month">
                                              Current Month
                                            </option>
                                            <option value="Current Year">
                                              Current Year
                                            </option>
                                            <option value="Year">Year</option>
                                            <option value="Month">Month</option>
                                          </select>
                                        )}
                                        {row.dataType === "timestamp" && (
                                          <select
                                            className="form-select"
                                            value={
                                              row.columnvalueOperator || ""
                                            }
                                            // onChange={
                                            //   this.handledataTypeOneChange
                                            // }
                                            onChange={(e) =>
                                              this.handleInputChange(index, e)
                                            }
                                            name="columnvalueOperator"
                                          >
                                            <option defaultValue>
                                              textOperators
                                            </option>
                                            <option value="=">=</option>
                                            <option value="<">&lt;</option>
                                            <option value=">">&gt;</option>
                                            <option value="<=">&le;</option>
                                            <option value=">=">&ge;</option>
                                            <option value="!=">
                                              &ne; Not Equal
                                            </option>
                                            <option value="Today">Today</option>
                                            <option value="Yesterday">
                                              Yesterday
                                            </option>
                                            <option value="Tomorrow">
                                              Tomorrow
                                            </option>
                                            <option value="Last N Days">
                                              Last N Days
                                            </option>
                                            <option value="Next N Days">
                                              Next N Days
                                            </option>
                                            <option value="Before">
                                              Before
                                            </option>
                                            <option value="Between">
                                              Between
                                            </option>
                                            <option value="Starts With">
                                              Starts With
                                            </option>
                                            <option value="Ends With">
                                              Ends With
                                            </option>
                                            <option value="Current Month">
                                              Current Month
                                            </option>
                                            <option value="Current Year">
                                              Current Year
                                            </option>
                                            <option value="Year">Year</option>
                                            <option value="Month">Month</option>
                                          </select>
                                        )}
                                      </>
                                    </Form.Group>
                                  </div>

                                  <div className="col">
                                    {this.renderConditionValueInput(index, row)}
                                  </div>
                                  <div className="col">
                                    {" "}
                                    <Form.Group controlId="textBox">
                                      <Form.Label>Logical Operators</Form.Label>
                                      <Form.Control
                                        as="select"
                                        className="form-select"
                                        value={row.logicalOperator}
                                        onChange={(e) =>
                                          this.handleInputChange(index, e)
                                        }
                                        // value={this.state.logicalOperator}
                                        // onChange={
                                        //   this.handlelogicalOperatorChange
                                        // }
                                        name="logicalOperator"
                                      >
                                        <option value="">Select</option>
                                        <option value="AND">AND</option>
                                        <option value="OR">OR</option>
                                        <option value="NOT">NOT</option>
                                      </Form.Control>
                                    </Form.Group>
                                  </div>
                                  <div className="col">
                                    {index === 0 ? (
                                      row.logicalOperator ? (
                                        <Button
                                          onClick={this.handleAddRow}
                                          style={{ marginTop: "30px" }}
                                          className="bi bi-plus"
                                        ></Button>
                                      ) : null
                                    ) : (
                                      <Button
                                        onClick={() =>
                                          this.handleRemoveRow(index)
                                        }
                                        style={{ marginTop: "30px" }}
                                        className="bi bi-trash"
                                      ></Button>
                                    )}
                                  </div>
                                </div>
                              ))}
                              <div className="row">
                                <div className="col">
                                  {" "}
                                  <Form.Group controlId="textBox">
                                    <Form.Label>Group By Column</Form.Label>
                                    <Form.Control
                                      as="select"
                                      className="form-select"
                                      value={this.state.groupbyColumn}
                                      onChange={this.handlegroupbyColumnChange}
                                      name="groupbyColumn"
                                    >
                                      <option value="">Select</option>
                                      {this.state.columns.map((api, index) => (
                                        <option
                                          key={index}
                                          value={api.COLUMN_NAME}
                                        >
                                          {api.COLUMN_NAME}
                                        </option>
                                      ))}
                                    </Form.Control>
                                  </Form.Group>
                                </div>
                                <div className="col">
                                  {" "}
                                  <Form.Group>
                                    <Form.Label>Group By</Form.Label>
                                    {this.state.groupbyColumnType === "date" ||
                                    this.state.groupbyColumnType ===
                                      "timestamp" ? (
                                      <Form.Select
                                        className="form-select"
                                        name="extractMonth"
                                        value={this.state.extractMonth}
                                        onChange={this.handleExactmonthChange}
                                      >
                                        <option value="">Select</option>
                                        <option value="MY">Month & Year</option>
                                        <option value="Y">Year</option>
                                        <option value="M">Month</option>
                                      </Form.Select>
                                    ) : (
                                      <p className="mt-2">
                                        No operators available for this type
                                      </p>
                                    )}
                                  </Form.Group>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col">
                                  {" "}
                                  <Form.Group controlId="textBox">
                                    <Form.Label>Drilldown Where</Form.Label>
                                    <Form.Control
                                      as="select"
                                      className="form-select"
                                      value={this.state.drilldownWhere}
                                      onChange={this.handlewheredrilldownChange}
                                      name="drilldownWhere"
                                    >
                                      <option value="">Select</option>
                                      {this.state.columns.map((api, index) => (
                                        <option
                                          key={index}
                                          value={api.COLUMN_NAME}
                                        >
                                          {api.COLUMN_NAME}
                                        </option>
                                      ))}
                                    </Form.Control>
                                  </Form.Group>
                                </div>
                                <div className="col">
                                  {" "}
                                  <Form.Group>
                                    <Form.Label>Operator</Form.Label>
                                    <Form.Select
                                      className="form-select"
                                      name="columnvalueOperator"
                                      onChange={this.handlevalueOperatorChange}
                                      value={this.state.valueOperator}
                                    >
                                      <option defaultValue>Operators </option>
                                      <option value="=">=</option>
                                      <option value="<">&lt;</option>
                                      <option value=">">&gt;</option>
                                      <option value="<=">&le;</option>
                                      <option value=">=">&ge;</option>
                                      <option value="!=">&ne; Not Equal</option>
                                      <option value="Is Empty">Is Empty</option>
                                      <option value="Is Not Empty">
                                        Is Not Empty
                                      </option>
                                    </Form.Select>
                                  </Form.Group>
                                </div>
                                <div className="col">
                                  {" "}
                                  <Form.Group>
                                    <Form.Label>Value</Form.Label>
                                    <Form.Control
                                      type="text"
                                      onChange={
                                        this.handleddrilldownvalueChange
                                      }
                                      className="form-control"
                                      name="drilldownvalue"
                                      value={this.state.drilldownvalue}
                                      placeholder="Enter Value"
                                    />
                                  </Form.Group>
                                </div>
                                <div className="col">
                                  {" "}
                                  <Form.Group>
                                    <Form.Label>Drilldown Group By</Form.Label>
                                    <Form.Control
                                      as="select"
                                      className="form-select"
                                      value={this.state.drilldownGroupby}
                                      onChange={this.handlegroupbyChange}
                                      name="drilldownGroupby"
                                    >
                                      <option value="">Select</option>
                                      {this.state.columns.map((api, index) => (
                                        <option
                                          key={index}
                                          value={api.COLUMN_NAME}
                                        >
                                          {api.COLUMN_NAME}
                                        </option>
                                      ))}
                                    </Form.Control>
                                  </Form.Group>
                                </div>
                                <div className="col">
                                  <Form.Group controlId="textBox">
                                    <Form.Label>Source report id</Form.Label>
                                    <Form.Control
                                      type="text"
                                      name="sourcereportId"
                                      value={this.state.sourcereportId}
                                      placeholder="Widget Name"
                                      onChange={(e) =>
                                        this.setState({
                                          sourcereportId: e.target.value,
                                        })
                                      }
                                    />
                                  </Form.Group>
                                </div>
                                <div className="col">
                                  <Form.Group controlId="textBox">
                                    <Form.Label>
                                      Destination report id
                                    </Form.Label>
                                    <Form.Control
                                      type="text"
                                      name="destinationreportId"
                                      value={this.state.destinationreportId}
                                      placeholder="Widget Name"
                                      onChange={(e) =>
                                        this.setState({
                                          destinationreportId: e.target.value,
                                        })
                                      }
                                    />
                                  </Form.Group>
                                </div>
                                <div className="col">
                                  <Form.Group controlId="textBox">
                                    <Form.Label>Employee Column</Form.Label>
                                    <select
                                      className="form-select"
                                      name="employeeColumn"
                                      value={this.state.employeeColumn}
                                      placeholder="Enter Employee Column"
                                      onChange={(e) =>
                                        this.setState({
                                          employeeColumn: e.target.value,
                                        })
                                      }
                                    >
                                      <option defaultValue>
                                        Select Employee
                                      </option>
                                      {this.state.columns.map((api, index) => (
                                        <option
                                          key={index}
                                          value={api.COLUMN_NAME}
                                        >
                                          {api.COLUMN_NAME}
                                        </option>
                                      ))}
                                    </select>
                                  </Form.Group>
                                </div>
                              </div>
                            </Card.Body>
                          </Card>
                        </Col>
                      )}
                      {/* CARD */}
                      {chartType === "CARD" && (
                        <Col>
                          <Card>
                            <Card.Body>
                              <h3>Configure Card Widget</h3>
                              <br />
                              <Row>
                                <Col lg="4">
                                  <Form.Group controlId="xAxisColumn">
                                    <Form.Label>Select Column</Form.Label>
                                    <Form.Control
                                      as="select"
                                      className="form-select"
                                      value={this.state.columnName}
                                      name="columnName"
                                      onChange={this.handleColumnChange}
                                    >
                                      <option value="">Select Column</option>
                                      {this.state.columns.map((api, index) => (
                                        <option
                                          key={index}
                                          value={api.COLUMN_NAME}
                                        >
                                          {api.COLUMN_NAME}
                                        </option>
                                      ))}
                                    </Form.Control>
                                  </Form.Group>
                                </Col>

                                <Col lg="4">
                                  <Form.Group>
                                    <Form.Label>Aggregation</Form.Label>
                                    <Form.Control
                                      as="select"
                                      className="form-select"
                                      value={this.state.aggregation}
                                      onChange={
                                        this.handleAggregateColumnChange
                                      }
                                      name="aggregation"
                                    >
                                      <option value="">Select</option>
                                      <option value="count">Count</option>
                                      <option value="sum">Sum</option>
                                      <option value="average">Average</option>
                                    </Form.Control>
                                  </Form.Group>
                                </Col>

                                <Col lg="4">
                                  <Form.Group>
                                    <Form.Label>Card Title</Form.Label>
                                    <Form.Control
                                      type="text"
                                      value={this.state.cardTitle}
                                      onChange={(e) =>
                                        this.setState({
                                          cardTitle: e.target.value,
                                        })
                                      }
                                      placeholder="e.g., Won Amount in Jun 2021"
                                    />
                                  </Form.Group>
                                </Col>
                              </Row>
                              <Row className="mt-2">
                                <Col lg="12">
                                  <Form.Check
                                    type="checkbox"
                                    id="mergeIntoSingleCard"
                                    label="Show as single card (merge all rows into one total)"
                                    checked={this.state.mergeIntoSingleCard}
                                    onChange={(e) =>
                                      this.setState({
                                        mergeIntoSingleCard: e.target.checked,
                                      })
                                    }
                                  />
                                </Col>
                              </Row>
                              <br />
                              <h3>Where Condition (Optional)</h3>
                              <br />
                              {this.state.rowscondition.map((row, index) => (
                                <div className="row" key={index}>
                                  <div className="col">
                                    <Form.Group controlId="textBox">
                                      <Form.Label>Select Column</Form.Label>
                                      <Form.Control
                                        as="select"
                                        className="form-select"
                                        value={row.columnName || ""}
                                        name="columnName"
                                        onChange={(e) =>
                                          this.handleColumnChangeone(index, e)
                                        }
                                      >
                                        <option value="">Select</option>
                                        {this.state.columns.map((api, idx) => (
                                          <option
                                            key={idx}
                                            value={api.COLUMN_NAME}
                                          >
                                            {api.COLUMN_NAME}
                                          </option>
                                        ))}
                                      </Form.Control>
                                    </Form.Group>
                                  </div>
                                  <div className="col">
                                    <Form.Group>
                                      <Form.Label>Operator</Form.Label>
                                      {[
                                        "varchar",
                                        "char",
                                        "text",
                                        "longtext",
                                        "mediumtext",
                                        "tinytext",
                                        "enum",
                                      ].includes(row.dataType) && (
                                        <Form.Select
                                          className="form-select"
                                          name="columnvalueOperator"
                                          onChange={(e) =>
                                            this.handleInputChange(index, e)
                                          }
                                          value={row.columnvalueOperator || ""}
                                        >
                                          <option value="">Select</option>
                                          <option value="=">=</option>
                                          <option value="!=">!=</option>
                                          <option value="Contains">
                                            Contains
                                          </option>
                                          <option value="Doesn't Contains">
                                            Doesn't Contains
                                          </option>
                                          <option value="Starts With">
                                            Starts With
                                          </option>
                                          <option value="Ends With">
                                            Ends With
                                          </option>
                                          <option value="Is Empty">
                                            Is Empty
                                          </option>
                                          <option value="Is Not Empty">
                                            Is Not Empty
                                          </option>
                                        </Form.Select>
                                      )}
                                      {[
                                        "int",
                                        "bigint",
                                        "smallint",
                                        "tinyint",
                                        "mediumint",
                                        "decimal",
                                        "float",
                                        "double",
                                        "numeric",
                                      ].includes(row.dataType) && (
                                        <Form.Select
                                          className="form-select"
                                          name="columnvalueOperator"
                                          onChange={(e) =>
                                            this.handleInputChange(index, e)
                                          }
                                          value={row.columnvalueOperator || ""}
                                        >
                                          <option value="">Select</option>
                                          <option value="=">=</option>
                                          <option value=">">&gt;</option>
                                          <option value="<">&lt;</option>
                                          <option value=">=">&ge;</option>
                                          <option value="<=">&le;</option>
                                          <option value="!=">
                                            &ne; Not Equal
                                          </option>
                                          <option value="Is Empty">
                                            Is Empty
                                          </option>
                                          <option value="Is Not Empty">
                                            Is Not Empty
                                          </option>
                                        </Form.Select>
                                      )}
                                      {[
                                        "timestamp",
                                        "date",
                                        "datetime",
                                      ].includes(row.dataType) && (
                                        <select
                                          className="form-select"
                                          value={row.columnvalueOperator || ""}
                                          onChange={(e) =>
                                            this.handleInputChange(index, e)
                                          }
                                          name="columnvalueOperator"
                                        >
                                          <option value="">Select</option>
                                          <option value="=">=</option>
                                          <option value="<">&lt;</option>
                                          <option value=">">&gt;</option>
                                          <option value="<=">&le;</option>
                                          <option value=">=">&ge;</option>
                                          <option value="!=">
                                            &ne; Not Equal
                                          </option>
                                          <option value="Today">Today</option>
                                          <option value="Yesterday">
                                            Yesterday
                                          </option>
                                          <option value="Tomorrow">
                                            Tomorrow
                                          </option>
                                          <option value="Last N Days">
                                            Last N Days
                                          </option>
                                          <option value="Next N Days">
                                            Next N Days
                                          </option>
                                          <option value="Before">Before</option>
                                          <option value="Between">
                                            Between
                                          </option>
                                          <option value="Starts With">
                                            Starts With
                                          </option>
                                          <option value="Ends With">
                                            Ends With
                                          </option>
                                          <option value="Current Month">
                                            Current Month
                                          </option>
                                          <option value="Current Year">
                                            Current Year
                                          </option>
                                          <option value="Year">Year</option>
                                          <option value="Month">Month</option>
                                        </select>
                                      )}
                                    </Form.Group>
                                  </div>
                                  <div className="col">
                                    {this.renderConditionValueInput(index, row)}
                                  </div>
                                  <div className="col">
                                    <Form.Group>
                                      <Form.Label>Logical Operator</Form.Label>
                                      <Form.Control
                                        as="select"
                                        className="form-select"
                                        value={row.logicalOperator}
                                        onChange={(e) =>
                                          this.handleInputChange(index, e)
                                        }
                                        name="logicalOperator"
                                      >
                                        <option value="">Select</option>
                                        <option value="AND">AND</option>
                                        <option value="OR">OR</option>
                                        <option value="NOT">NOT</option>
                                      </Form.Control>
                                    </Form.Group>
                                  </div>
                                  <div className="col">
                                    {index === 0 ? (
                                      row.logicalOperator ? (
                                        <Button
                                          onClick={this.handleAddRow}
                                          style={{ marginTop: "30px" }}
                                          className="bi bi-plus"
                                        ></Button>
                                      ) : null
                                    ) : (
                                      <Button
                                        onClick={() =>
                                          this.handleRemoveRow(index)
                                        }
                                        style={{ marginTop: "30px" }}
                                        className="bi bi-trash"
                                      ></Button>
                                    )}
                                  </div>
                                </div>
                              ))}
                              <div className="row">
                                <div className="col">
                                  {" "}
                                  <Form.Group controlId="textBox">
                                    <Form.Label>Group By Column</Form.Label>
                                    <Form.Control
                                      as="select"
                                      className="form-select"
                                      value={this.state.groupbyColumn}
                                      onChange={this.handlegroupbyColumnChange}
                                      name="groupbyColumn"
                                    >
                                      <option value="">Select</option>
                                      {this.state.columns.map((api, index) => (
                                        <option
                                          key={index}
                                          value={api.COLUMN_NAME}
                                        >
                                          {api.COLUMN_NAME}
                                        </option>
                                      ))}
                                    </Form.Control>
                                  </Form.Group>
                                </div>
                                <div className="col">
                                  {" "}
                                  <Form.Group>
                                    <Form.Label>Group By</Form.Label>
                                    {this.state.groupbyColumnType === "date" ||
                                    this.state.groupbyColumnType ===
                                      "timestamp" ? (
                                      <Form.Select
                                        className="form-select"
                                        name="extractMonth"
                                        value={this.state.extractMonth}
                                        onChange={this.handleExactmonthChange}
                                      >
                                        <option value="">Select</option>
                                        <option value="MY">Month & Year</option>
                                        <option value="Y">Year</option>
                                        <option value="M">Month</option>
                                      </Form.Select>
                                    ) : (
                                      <p className="mt-2">
                                        No operators available for this type
                                      </p>
                                    )}
                                  </Form.Group>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col">
                                  <Form.Group controlId="textBox">
                                    <Form.Label>Source report id</Form.Label>
                                    <Form.Control
                                      type="text"
                                      name="sourcereportId"
                                      value={this.state.sourcereportId}
                                      placeholder="Widget Name"
                                      onChange={(e) =>
                                        this.setState({
                                          sourcereportId: e.target.value,
                                        })
                                      }
                                    />
                                  </Form.Group>
                                </div>
                                <div className="col">
                                  <Form.Group controlId="textBox">
                                    <Form.Label>
                                      Destination report id
                                    </Form.Label>
                                    <Form.Control
                                      type="text"
                                      name="destinationreportId"
                                      value={this.state.destinationreportId}
                                      placeholder="Widget Name"
                                      onChange={(e) =>
                                        this.setState({
                                          destinationreportId: e.target.value,
                                        })
                                      }
                                    />
                                  </Form.Group>
                                </div>
                                <div className="col">
                                  <Form.Group controlId="textBox">
                                    <Form.Label>Employee Column</Form.Label>
                                    <select
                                      className="form-select"
                                      name="employeeColumn"
                                      value={this.state.employeeColumn}
                                      placeholder="Enter Employee Column"
                                      onChange={(e) =>
                                        this.setState({
                                          employeeColumn: e.target.value,
                                        })
                                      }
                                    >
                                      <option defaultValue>
                                        Select Employee
                                      </option>
                                      {this.state.columns.map((api, index) => (
                                        <option
                                          key={index}
                                          value={api.COLUMN_NAME}
                                        >
                                          {api.COLUMN_NAME}
                                        </option>
                                      ))}
                                    </select>
                                  </Form.Group>
                                </div>
                              </div>
                            </Card.Body>
                          </Card>
                        </Col>
                      )}
                    </Row>
                  </Form>
                  <Button
                    variant="info"
                    className="btn btn-info"
                    onClick={this.HandlePreviewsubmitHandler}
                    disabled={this.state.isSubmitting}
                    style={{ marginTop: "5px" }}
                  >
                    Preview Chart
                  </Button>
                  <Button
                    variant="success"
                    className="btn btn-success"
                    style={{ float: "right", marginTop: "5px" }}
                    onClick={this.WidgetslibrarysubmitHandler}
                  >
                    Save Configuration
                  </Button>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        )}
        <br />
        <div>
          <Row>
            <Col lg="12">{this.renderChartPreview()}</Col>
          </Row>
        </div>
      </div>
    );
  }
}
